<template>
  <div :class="embedded ? '' : columnClassName">
    <column-header v-if="!embedded" :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="(embedded ? '' : 'tabulator-parent') + (embedded || !bodyClassName ? '' : ' ' + bodyClassName)">
      <div class="row" v-if="!(embedded && hasFocus)">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-cog"></i> {{ _('General settings') }}</h3>
        </div>
      </div>
      <div class="row" v-else-if="embedded && hasFocus">
        <div class="col-md-12">
          <h3>{{ _('Price tiers') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" v-show="!hasFocus" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('paymentmethods')" class="tab-pane active" id="paymentmethods" v-if="isTabActive('paymentmethods')" key="paymentmethods">
            <div class="row" v-show="!hasFocus">
              <div class="col-sm-6 leftcol">
                <h3>{{ _('Payment Methods') }}</h3>
                <h4>{{ _('Online and In-Store Payments') }}</h4>
                <div class="panel-group flex-panel" id="accordionOnlineInstore" role="tablist" aria-multiselectable="true">
                  <!-- Mobilepay -->
                  <div :class="paymentPanelClass(18)" v-if="isFeatureEnabled('mobilepay')">
                    <div class="panel-heading" role="tab" id="headingEighteen">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseEighteen" v-on:click="togglePanel('eighteen')">
                        <span class="title-text">{{ _('MobilePay') }}</span>
                        <span class="label label-info" v-if="isMobilePaySet && parseInt(settings.pay_option18)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="label label-success" v-if="isMobilePaySet"><i class="fa fa-fw fa-shopping-basket"></i><span class="hidden-xs"> {{_('In-store') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseEighteen" class="panel-collapse" role="tabpanel" aria-labelledby="headingEighteen" v-if="isPanelOpen('eighteen')" >
                        <div class="panel-body">
                          <div v-if="mobilepayOnboardingStatuses.length > 0" class="alert alert-info" style="padding-top: 5px">
                            <h3>{{ _('Onboarding status') }} <button style="float: right" class="btn btn-primary btn-xs" v-on:click="checkMobilepayOnboardingStatuses"><i :class="checkingMobilepayOnboardingStatuses ? 'fa fa-fw fa-refresh fa-spin' : 'fa fa-fw fa-refresh'"></i></button></h3>
                            <div v-for="status in mobilepayOnboardingStatuses">
                              <h4>{{ status.type == 'online' ? _('Online payments (Storefront)') : _('In-store payments') }}</h4>
                              <p>{{ _('Status') }}: {{ parseMobilepayOnboardingStatus(status.status) }}</p>
                              <p v-if="status.status === 'SENT' || status.status === 'RECEIVED' || status.status === 'MERCHANT_VIEWED'"><a class="btn btn-primary" :href="status.url" target="_blank"><i class="fa fa-fw fa-arrow-up-right-from-square"></i> {{ _('Complete onboarding') }}</a></p>
                            </div>
                          </div>
                          <div class="mobile-pay-buttons" style="display: flex; flex-wrap: wrap; justify-content:space-between">
                            <button v-if="(!hasMobilepayMsnValue(settings.pay_option18_msn) && !hasMobilepayMsnValue(settings.pay_option18_msn_pos)) || (hasMobilepayOnboardingExpired('online') && hasMobilepayOnboardingExpired('pos'))" type="button" class="btn btn-primary" v-on:click="onboardMobilepay('both')"><i class="fa fa-fw fa-plus"></i> {{ _('Enable online and in-store payments') }}</button>
                            <template v-else>
                              <button v-if="!hasMobilepayMsnValue(settings.pay_option18_msn) || hasMobilepayOnboardingExpired('online')" type="button" class="btn btn-primary" v-on:click="onboardMobilepay('online')"><i class="fa fa-fw fa-plus"></i> {{ _('Enable online payments') }}</button>
                              <button v-if="!hasMobilepayMsnValue(settings.pay_option18_msn_pos) || hasMobilepayOnboardingExpired('pos')" type="button" class="btn btn-primary" v-on:click="onboardMobilepay('pos')"><i class="fa fa-fw fa-plus"></i> {{ _('Enable in-store payments') }}</button>
                            </template>
                          </div>
                          <hr v-if="!isMobilePaySetOnline || !isMobilePaySetPos">
                          <template v-if="isMobilePaySetOnline || isMobilePaySetPos">
                            <div class="form-group" v-if="hasMobilepayMsnValue(settings.pay_option18_msn) || hasMobilepayMsnValue(settings.pay_option18_msn_pos)">
                              <button type="button" class="btn btn-info" v-on:click="showMobilepayAttempts"><i class="fa fa-fw fa-money-check"></i> {{ _('Payment attempts') }}</button>
                            </div>
                            <div class="form-group languageversioned">
                              <label for="payOption18Title">{{ _('Title') }}</label>
                              <input type="text" class="form-control" id="payOption18Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option18_title" />
                            </div>
                            <div class="form-group">
                              <label>
                              <input type="checkbox" v-model="settings.pay_option18_button" true-value="1" false-value="0" />
                              <span>{{ _('Enable direct purchase button') }}</span>
                              </label>
                            </div>
                            <div class="form-group">
                              <label for="pay_option18_branding">{{ _('Branding') }}</label>
                              <select id="mobilepayBranding" v-model="settings.pay_option18_branding" class="form-control">
                                <option value="mobilepay">{{ _('MobilePay') }}</option>
                                <option value="vipps">{{ _('Vipps') }}</option>
                                <option value="vippsmobilepay">{{ _('Vipps MobilePay') }}</option>
                              </select>
                            </div>
                            <div class="form-group" v-if="isMobilePaySetOnline">
                              <label for="payOption18Msn">{{ _('Merchant serial number') }} ({{ _('Storefront') }})</label>
                              <input type="text" class="form-control" id="payOption18Msn" :placeholder="_('Enter your MobilePay Merchant serial number')" v-model="settings.pay_option18_msn" :disabled="true" />
                            </div>
                            <div class="form-group" v-if="isMobilePaySetPos">
                              <label for="payOption18MsnPos">{{ _('Merchant serial number') }} ({{ _('POS') }})</label>
                              <input type="text" class="form-control" id="payOption18MsnPos" :placeholder="_('Enter your MobilePay Merchant serial number')" v-model="settings.pay_option18_msn_pos" :disabled="true" />
                            </div>
                            <div class="form-group" v-if="isMobilePaySetOnline">
                              <label>{{ _('Automatic renewals') }}</label>
                              <p>
                                <span v-if="Number(settings.pay_option18_recurring)" class="label label-success">{{ _('In use') }}</span>
                                <span v-else class="label label-default">{{ _('Not in use') }}</span>
                                <span v-if="settings.pay_option18_recurring_checked_ts" class="text-muted small"> {{ _('Checked %s').replace('%s', formatMobilepayCheckedTs(settings.pay_option18_recurring_checked_ts)) }}</span>
                              </p>
                              <p class="help-block">{{ _('Customers can pay the renewals of recurring subscriptions automatically with a MobilePay agreement. To use this, open your sales unit in the Vipps MobilePay business portal, choose Recurring Payments and Add. Then check the status here.') }}</p>
                              <p><a class="btn btn-default" href="https://portal.vippsmobilepay.com" target="_blank" rel="noopener"><i class="fa fa-fw fa-arrow-up-right-from-square"></i> {{ _('Open business portal') }}</a></p>
                              <label for="payOption18MsnRecurring">{{ _('Separate sales unit for recurring payments (optional)') }}</label>
                              <div class="input-group">
                                <input type="text" inputmode="numeric" class="form-control" id="payOption18MsnRecurring" :placeholder="settings.pay_option18_msn" v-model="mobilepayRecurringMsnInput" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-primary" v-on:click="checkMobilepayRecurring" :disabled="checkingMobilepayRecurring"><i :class="'fa fa-fw fa-refresh' + (checkingMobilepayRecurring ? ' fa-spin' : '')"></i> {{ _('Check status') }}</button>
                                </span>
                              </div>
                              <p class="help-block">{{ _('Leave empty to use the storefront sales unit.') }}</p>
                            </div>
                            <div class="form-group" v-if="isNetvisorConfigured">
                              <label for="payOption18NetvisorAccount">{{ _('Netvisor account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control netvisor-account" id="payOption18NetvisorAccount" disabled="disabled" :value="settings.pay_option18_netvisoraccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option18_netvisoraccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option18_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option18_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option18_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option18_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option18" true-value="1" false-value="0" :disabled="isMobilePaySetOnline ? false : true"/>
                              <span>{{ _('Selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Mobilepay -->
                  <!-- Viva Wallet -->
                  <div :class="paymentPanelClass(19)" v-if="isFeatureEnabled('viva')">
                    <div class="panel-heading" role="tab" id="headingNineteen">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseNineteen" v-on:click="togglePanel('nineteen')">
                        <span class="title-text">{{ _('Viva') }}</span>
                        <span class="label label-info" v-if="isVivaSet && parseInt(settings.pay_option19)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="label label-success" v-if="isVivaSet"><i class="fa fa-fw fa-shopping-basket"></i><span class="hidden-xs"> {{_('In-store') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseNineteen" class="panel-collapse" role="tabpanel" aria-labelledby="headingNineteen" v-if="isPanelOpen('nineteen')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="payOption19Title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption19Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option19_title" />
                          </div>
                          <div v-if="vivaOnboardingStatus && !settings.pay_option19_merchantid" class="alert alert-info" style="padding-top: 5px">
                            <h3>{{ _('Onboarding status') }} <button style="float: right" class="btn btn-primary btn-xs" v-on:click="checkVivaOnboardingStatus"><i :class="checkingVivaOnboardingStatus ? 'fa fa-fw fa-refresh fa-spin' : 'fa fa-fw fa-refresh'"></i></button></h3>
                            <p>{{ _('Status') }}: {{ parseVivaOnboardingStatus(vivaOnboardingStatus.status) }}</p>
                            <p v-if="vivaOnboardingStatus.status === 'SENT' && vivaOnboardingStatus.url"><a class="btn btn-primary" :href="vivaOnboardingStatus.url" target="_blank"><i class="fa fa-fw fa-arrow-up-right-from-square"></i> {{ _('Complete onboarding') }}</a></p>
                            <p>{{ _('The Merchant ID is filled in automatically once Viva has verified the account.') }}</p>
                          </div>
                          <div class="form-group" v-if="!settings.pay_option19_merchantid && !vivaOnboardingStatus">
                            <button type="button" class="btn btn-info" v-on:click="createVivaAccountDialog">{{ _('Create account') }}</button>
                          </div>
                          <div class="form-group">
                            <label for="payOption19MerchantId">{{ _('Merchant ID') }}</label>
                            <input type="text" class="form-control" id="payOption19MerchantId" :placeholder="_('Enter your Viva Merchant ID')" v-model="settings.pay_option19_merchantid" />
                          </div>
                          <div class="form-group">
                            <label for="payOption19ExtraEur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption19ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option19_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="payOption19ExtraPerc">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption19ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option19_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="payOption19NetvisorAccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" id="payOption19NetvisorAccount" disabled="disabled" :value="settings.pay_option19_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option19_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option19_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option19_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option19_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option19_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option19" true-value="1" false-value="0" :disabled="isVivaSet ? false : true"/>
                              <span>{{ _('Selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Viva Wallet-->
                  <!-- Visma pay -->
                  <div :class="paymentPanelClass(9)">
                    <div class="panel-heading" role="tab" id="headingNine">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseNine" v-on:click="togglePanel('nine')">
                        <span class="title-text">{{ _('Visma Pay') }}</span>
                        <span class="label label-info" v-if="isVismaPaySet && parseInt(settings.pay_option9)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="label label-success" v-if="isVismaPaySet"><i class="fa fa-fw fa-shopping-basket"></i><span class="hidden-xs"> {{_('In-store') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseNine" class="panel-collapse" role="tabpanel" aria-labelledby="headingNine" v-if="isPanelOpen('nine')">
                        <div class="panel-body">
                          <visma-boarding v-if="!settings.pay_option9_privatekey && !settings.pay_option9_apikey" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :settings="settings" />

                          <div class="form-group languageversioned">
                            <label for="pay_option9_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption9Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option9_title" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option9_privatekey">{{ _('Private encryption key') }}</label>
                            <input type="text" class="form-control" id="payOption9PrivateKey" :placeholder="_('Enter your Visma Pay private encryption key')" v-model="settings.pay_option9_privatekey" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option9_apikey">{{ _('Private API key') }}</label>
                            <input type="text" class="form-control" id="payOption9ApiKey" :placeholder="_('Enter your Visma Pay private API key')" v-model="settings.pay_option9_apikey" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option9_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption9ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option9_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option9_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption9ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option9_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option9_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option9_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option9_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option9_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option9_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option9_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option9_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option9" true-value="1" false-value="0" :disabled="isVismaPaySet ? false : true"/>
                              <span>{{ _('Selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Visma Pay-->
                </div>
                <h4>{{ _('Online payments') }}</h4>
                <div class="panel-group flex-panel" id="accordionOnline" role="tablist" aria-multiselectable="true">
                  <!-- Netaxept -->
                  <div :class="paymentPanelClass(17)" v-if="isFeatureEnabled('netaxept')">
                    <div class="panel-heading" role="tab" id="headingSeventeen">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseSeventeen" v-on:click="togglePanel('seventeen')">
                        <span class="title-text">{{ _('Netaxept') }}</span>
                        <span class="label label-info" v-if="isNetaxeptSet && parseInt(settings.pay_option17)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseSeventeen" class="panel-collapse" role="tabpanel" aria-labelledby="headingSeventeen" v-if="isPanelOpen('seventeen')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option17_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption17Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option17_title" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option17_merchantid">{{ _('Merchant ID') }}</label>
                            <input type="text" class="form-control" id="payOption17MerchantId" :placeholder="_('Enter your Netaxept Merchant ID')" v-model="settings.pay_option17_merchantid" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option17_apitoken">{{ _('API token') }}</label>
                            <input type="text" class="form-control" id="payOption17ApiToken" :placeholder="_('Enter your Netaxept API token')" v-model="settings.pay_option17_apitoken" />
                          </div>
                          <div class="form-group">
                            <label for="loyaltyType">{{ _('Bonus') }}</label>
                            <select id="loyaltyType" class="form-control" v-model="settings.pay_option17_loyalty">
                              <option value="">{{ _('Not in use') }}</option>
                              <option value="bonus">{{ _('Bonus') }}</option>
                              <option value="both">{{ _('Bonus and payment method benefit') }}</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label for="pay_option17_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption17ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option17_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option17_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption17ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option17_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option17_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option17_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option17_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option17_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option17_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option17_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option17_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option17" true-value="1" false-value="0" :disabled="isNetaxeptSet ? false : true"/>
                              <span>{{ _('Enabled and selectable for online orders')}}</span><br>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Netaxept -->
                  <!-- Paytrail -->
                  <div :class="paymentPanelClass(6)">
                    <div class="panel-heading" role="tab" id="headingSeven">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseSeven" v-on:click="togglePanel('seven')">
                        <span class="title-text">{{ _('Paytrail') }}</span>
                        <span class="label label-info" v-if="isPaytrailSet && parseInt(settings.pay_option6)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseSeven" class="panel-collapse" role="tabpanel" aria-labelledby="headingSeven" v-if="isPanelOpen('seven')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option6_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption6Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option6_title" />
                          </div>
                          <div class="form-group" v-if="!isPaytrailSet">
                            <button type="button" class="btn btn-info" v-on:click="createPaytrailAccount" :disabled="creatingPaytrailAccount || !isPaytrailCompanyReady">{{ _('Create Paytrail account') }}</button>
                            <p class="help-block" v-if="!isPaytrailCompanyReady">{{ _('Please fill in all company profile fields before creating a Paytrail account.') }}</p>
                            <p class="help-block" v-else>{{ _('We will send a Paytrail merchant application using your company profile. If you already have an account, enter the merchant ID and secret key below.') }}</p>
                          </div>
                          <div class="form-group">
                            <label for="pay_option6_merchantid">{{ _('Merchant ID') }}</label>
                            <input type="text" class="form-control" id="payOption6MerchantId" :placeholder="_('Enter your Paytrail merchant ID')" v-model="settings.pay_option6_merchantid" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option6_merchantcode">{{ _('Password') }}</label>
                            <input type="text" class="form-control" id="payOption6MerchantCode" :placeholder="_('Enter your Paytrail secret key')" v-model="settings.pay_option6_merchantcode" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option6_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption6ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option6_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option6_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption6ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option6_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option6_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option6_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option6_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option6_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option6_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option6_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option6_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option6" true-value="1" false-value="0" :disabled="isPaytrailSet ? false : true"/>
                              <span>{{ _('Enabled and selectable for online orders')}}</span><br>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Paytrail -->
                  <!-- Stripe -->
                  <div :class="paymentPanelClass(8)">
                    <div class="panel-heading" role="tab" id="headingEight">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseEight" v-on:click="togglePanel('eight')">
                        <span class="title-text">{{ _('Stripe') }}</span>
                        <span class="label label-info" v-if="isStripeSet && parseInt(settings.pay_option8)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseEight" class="panel-collapse" role="tabpanel" aria-labelledby="headingEight" v-if="isPanelOpen('eight')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option8_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption8Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option8_title" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option8_secretkey">{{ _('Secret key') }}</label>
                            <input type="text" class="form-control" id="payOption8SecretKey" :placeholder="_('Enter your Stripe secret key')" v-model="settings.pay_option8_secretkey" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option8_publishablekey">{{ _('Publishable key') }}</label>
                            <input type="text" class="form-control" id="payOption8PublishableKey" :placeholder="_('Enter your Stripe publishable key')" v-model="settings.pay_option8_publishablekey" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option8_signingsecret">{{ _('Webhook signing secret') }}</label>
                            <input type="text" class="form-control" id="payOption8SigningSecret" :placeholder="_('Enter your Stripe webhook signing secret')" v-model="settings.pay_option8_signingsecret" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option8_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption8ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option8_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option8_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption8ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option8_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option8_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option8_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option8_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option8_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option8_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option8_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option8_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option8" true-value="1" false-value="0" :disabled="isStripeSet ? false : true"/>
                              <span>{{ _('Enabled and selectable for online orders')}}</span><br>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Stripe -->
                  <!-- Stripe (Alipay) -->
                  <div :class="paymentPanelClass(12)" v-if="isAdmin">
                    <div class="panel-heading" role="tab" id="headingTwelve">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseTwelve" v-on:click="togglePanel('twelve')">
                        <span class="title-text">{{ _('Alipay') }} ({{ _('via Stripe') }})</span>
                        <span class="label label-info" v-if="isAlipaySet && parseInt(settings.pay_option12)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseTwelve" class="panel-collapse" role="tabpanel" aria-labelledby="headingTwelve" v-if="isPanelOpen('twelve')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option12_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption12Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option12_title"  />
                          </div>
                          <div class="form-group">
                            <label for="pay_option12_secretkey">{{ _('Secret key') }}</label>
                            <input type="text" class="form-control" id="payOption12SecretKey" :placeholder="_('Enter your Stripe secret key')" v-model="settings.pay_option12_secretkey" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option12_publishablekey">{{ _('Publishable key') }}</label>
                            <input type="text" class="form-control" id="payOption12PublishableKey" :placeholder="_('Enter your Stripe publishable key')" v-model="settings.pay_option12_publishablekey" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option12_signingsecret">{{ _('Webhook signing secret') }}</label>
                            <input type="text" class="form-control" id="payOption12SigningSecret" :placeholder="_('Enter your Stripe webhook signing secret')" v-model="settings.pay_option12_signingsecret" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option12_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption12ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option12_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option12_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption12ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option12_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option12_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option12_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option12_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option12_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option12_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option12_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option12_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option12" true-value="1" false-value="0" :disabled="isAlipaySet ? false : true"/>
                              <span>{{ _('Enabled and selectable for online orders')}}</span><br>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Stripe (Alipay) -->
                  <!-- PayPal -->
                  <div :class="paymentPanelClass(3)">
                    <div class="panel-heading" role="tab" id="headingFour">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseFour" v-on:click="togglePanel('four')">
                        <span class="title-text">{{ _('PayPal') }}</span>
                        <span class="label label-info" v-if="isPayPalSet && parseInt(settings.pay_option3)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseFour" class="panel-collapse" role="tabpanel" aria-labelledby="headingFour" v-if="isPanelOpen('four')">
                        <div class="panel-body">
                          <h4>{{ _('API credentials (PayPal)') }}</h4>
                          <div class="form-group">
                            <label for="pay_option3_mode">{{ _('Display payment options') }}</label>
                            <select id="paypalOptions" v-model="settings.pay_option3_mode" class="form-control">
                              <option value="0">{{ _('PayPal Account and Credit Cards') }}</option>
                              <option value="1">{{ _('PayPal Account only') }}</option>
                              <option value="2">{{ _('Credit Cards only') }}</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label for="pay_option3_user">{{ _('User') }}</label>
                            <input type="text" class="form-control" id="payOption3User" :placeholder="_('Enter the user id')" v-model="settings.pay_option3_user" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option3_pwd">{{ _('Password') }}</label>
                            <input type="text" class="form-control" id="payOption3Pwd" :placeholder="_('Enter the password')" v-model="settings.pay_option3_pwd" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option3_signature">{{ _('PayPal Signature') }}</label>
                            <input type="text" class="form-control" id="payOption3Signature" :placeholder="_('Enter the signature')" v-model="settings.pay_option3_signature" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option3_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption3ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option3_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option3_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption3ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option3_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option3_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option3_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option3_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option3_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option3_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option3_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option3_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                          <div class="alert alert-warning">
                            <button class="btn btn-warning" @click="showPayPalSandBox = !showPayPalSandBox"><i class="fa fa-fw fa-construction"></i> {{ _('Additional settings') }}: {{ _('PayPal SANDBOX') }}</button>
                            <div v-if="showPayPalSandBox">
                              <!-- Sandbox -->
                              <hr>
                              <h4>{{ _('API credentials (PayPal SANDBOX)') }}</h4>
                              <div class="form-group">
                                <label for="pay_option4_mode">{{ _('Display payment options') }}</label>
                                <select id="paypalOptions" v-model="settings.pay_option4_mode" class="form-control">
                                  <option value="0">{{ _('PayPal Account and Credit Cards') }}</option>
                                  <option value="1">{{ _('PayPal Account only') }}</option>
                                  <option value="2">{{ _('Credit Cards only') }}</option>
                                </select>
                              </div>
                              <div class="form-group">
                                <label for="pay_option4_user">{{ _('User') }}</label>
                                <input type="text" class="form-control" id="payOption4User" :placeholder="_('Enter the user id')" v-model="settings.pay_option4_user" />
                              </div>
                              <div class="form-group">
                                <label for="pay_option4_pwd">{{ _('Password') }}</label>
                                <input type="text" class="form-control" id="payOption4Pwd" :placeholder="_('Enter the password')" v-model="settings.pay_option4_pwd" />
                              </div>
                              <div class="form-group">
                                <label for="pay_option4_signature">{{ _('PayPal Signature') }}</label>
                                <input type="text" class="form-control" id="payOption4Signature" :placeholder="_('Enter the signature')" v-model="settings.pay_option4_signature" />
                              </div>
                              <div class="form-group">
                                <label for="pay_option4_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                                <div class="input-group">
                                  <input type="text" class="form-control" id="payOption4ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option4_extraeur" />
                                  <div class="input-group-addon">{{ settings.currency }}</div>
                                </div>
                              </div>
                              <div class="form-group">
                                <label for="pay_option4_extraeur">{{ _('Surcharge') }} (%)</label>
                                <div class="input-group">
                                  <input type="text" class="form-control" id="payOption4ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option4_extraperc" />
                                  <div class="input-group-addon">%</div>
                                </div>
                              </div>
                              <div class="form-group">
                                <label>
                                  <input type="checkbox" v-model="settings.pay_option4" true-value="1" false-value="0" :disabled="isPayPalSandboxSet ? false : true"/>
                                  <span>{{ _('Enabled and selectable for online orders')}}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option3" true-value="1" false-value="0" :disabled="isPayPalSet ? false : true"/>
                              <span>{{ _('Enabled and selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /PayPal -->
                </div>
                <h4>{{ _('Benefits') }}</h4>
                <div class="panel-group flex-panel" id="accordionBenefits" role="tablist" aria-multiselectable="true">
                  <!-- Epassi -->
                  <div :class="paymentPanelClass(15)">
                    <div class="panel-heading" role="tab" id="headingFifteen">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseFifteen" v-on:click="togglePanel('fifteen')">
                        <span class="title-text">{{ _('ePassi') }}</span>
                        <span class="label label-info" v-if="isEpassiSet && parseInt(settings.pay_option15)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseFifteen" class="panel-collapse" role="tabpanel" aria-labelledby="headingFifteen" v-if="isPanelOpen('fifteen')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option15_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payoption15Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option15_title" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option15_site">{{ _('Site ID') }}</label>
                            <input type="text" class="form-control" id="payoption15SiteId" :placeholder="_('Enter your ePassi Site ID')" v-model="settings.pay_option15_siteid" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option15_mac">{{ _('MAC key') }}</label>
                            <input type="text" class="form-control" id="payoption15Mac" :placeholder="_('Enter your ePassi secret MAC key')" v-model="settings.pay_option15_mac" />
                          </div>
                          <div class="form-group" v-if="parseInt(settings.pay_option15_extraeur) || parseFloat(settings.pay_option15_extraeur) > 0">
                            <label for="pay_option15_extraeur" class="text-danger">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payoption15ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option15_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="parseInt(settings.pay_option15_extraperc) || parseFloat(settings.pay_option15_extraperc) > 0">
                            <label for="pay_option15_extraeur" class="text-danger">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control is-invalid" id="payoption15ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option15_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option15_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option15_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option15_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option15_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option15_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option15_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option15_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option15" true-value="1" false-value="0" :disabled="isEpassiSet ? false : true"/>
                              <span>{{ _('Enabled and selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Epassi -->
                  <!-- Edenred -->
                  <div :class="paymentPanelClass(16)">
                    <div class="panel-heading" role="tab" id="headingSixteen">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseSixteen" v-on:click="togglePanel('sixteen')">
                        <span class="title-text">{{ _('Edenred') }}</span>
                        <span class="label label-info" v-if="isEdenredSet && parseInt(settings.pay_option16)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseSixteen" class="panel-collapse" role="tabpanel" aria-labelledby="headingSixteen" v-if="isPanelOpen('sixteen')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option16_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payoption16Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option16_title" />
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option16_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option16_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option16_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                            </div>
                            <div class="form-group" v-if="isBrioxConfigured">
                              <label>{{ _('Briox payment method') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option16_brioxpaymentmethod)" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option16_brioxpaymentmethod')">{{ _('Select') }}</button>
                                </span>
                              </div>
                          </div>
                            <div class="form-group" v-if="isNocfoConfigured">
                              <label>{{ _('NoCFO account') }}</label>
                              <div class="input-group">
                                <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option16_nocfoaccount" />
                                <span class="input-group-btn">
                                  <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option16_nocfoaccount')">{{ _('Select') }}</button>
                                </span>
                              </div>
                            </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option16" true-value="1" false-value="0" :disabled="isEdenredSet ? false : true"/>
                              <span>{{ _('Enabled and selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- /Edenred -->
                </div>
                <h4>{{ _('Billing') }}</h4>
                <div class="panel-group flex-panel" id="accordionBilling" role="tablist" aria-multiselectable="true">
                  <div :class="paymentPanelClass(1)">
                    <div class="panel-heading" role="tab" id="headingThree">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseThree" v-on:click="togglePanel('three')">
                        <span class="title-text">{{ _('Invoice') }}</span>
                        <span class="label label-info" v-if="(isInvoiceSet || isRopoInvoiceSet || isNetvisorInvoiceSet || isBrioxInvoiceSet || isNocfoInvoiceSet) && parseInt(settings.pay_option1)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="label label-success" v-if="(isInvoiceSet || isRopoInvoiceSet || isNetvisorInvoiceSet || isBrioxInvoiceSet || isNocfoInvoiceSet)"><i class="fa fa-fw fa-shopping-basket"></i><span class="hidden-xs"> {{_('In-store') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseThree" class="panel-collapse" role="tabpanel" aria-labelledby="headingThree" v-if="isPanelOpen('three')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option1_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="exampleInputEmail1" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option1_title" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option1_duedays">{{ _('Due days') }}</label>
                            <div class="input-group">
                              <input type="number" data-android-inputmode="decimal" class="form-control" id="payOption1DueDays" :placeholder="_('for example 14')" v-model="settings.pay_option1_duedays" />
                              <div class="input-group-addon"> {{ _('d') }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option1_noticedays">{{ _('Notice days') }}</label>
                            <div class="input-group">
                              <input type="number" data-android-inputmode="decimal" class="form-control" id="payOption1NoticeDays" :placeholder="_('for example 7')" v-model="settings.pay_option1_noticedays" />
                              <div class="input-group-addon"> {{ _('d') }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option1_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption1ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option1_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option1_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption1ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option1_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>


                          <h4>{{ _('Active invoice types')}}</h4>

                          <div>
                            <label><input type="checkbox" :checked="isInvoiceSet && !(parseInt(settings.pay_option7) || parseInt(settings.pay_option13) || parseInt(settings.pay_option20) || parseInt(settings.pay_option21))" :disabled="true"/> {{ _('Johku Invoice (PDF)') }}</label>
                            <span class="label label-info" v-if="isInvoiceSet && !(parseInt(settings.pay_option7) || parseInt(settings.pay_option13) || parseInt(settings.pay_option20) || parseInt(settings.pay_option21))">{{ _('Active') }}</span>
                          </div>
                          <div>
                            <label><input type="checkbox" v-model="settings.pay_option7" true-value="1" false-value="0" :disabled="isRopoInvoiceSet ? false : true"/> {{ _('Ropo Invoice') }}</label>
                            <span class="label label-info" v-if="parseInt(settings.pay_option7)">{{ _('Active') }}</span>
                          </div>
                          <div>
                            <label><input type="checkbox" v-model="settings.pay_option13" true-value="1" false-value="0" :disabled="isNetvisorInvoiceSet ? false : true"/> {{ _('Netvisor Invoice') }}</label>
                            <span class="label label-info" v-if="parseInt(settings.pay_option13)">{{ _('Active') }}</span>
                          </div>
                          <div v-if="isBrioxSetupVisible">
                            <label><input type="checkbox" v-model="settings.pay_option20" true-value="1" false-value="0" :disabled="isBrioxInvoiceSet ? false : true"/> {{ _('Briox Invoice') }}</label>
                            <span class="label label-info" v-if="parseInt(settings.pay_option20)">{{ _('Active') }}</span>
                          </div>
                          <div v-if="isNocfoSetupVisible">
                            <label><input type="checkbox" v-model="settings.pay_option21" true-value="1" false-value="0" :disabled="isNocfoInvoiceSet ? false : true"/> {{ _('NoCFO Invoice') }}</label>
                            <span class="label label-info" v-if="parseInt(settings.pay_option21)">{{ _('Active') }}</span>
                          </div>

                          <h4>{{ _('Additional settings')}}</h4>

                          <editor-tabs :tabs="billingTabList" :selected="activeBillingTab" v-on:select="billingTab" />

                          <div class="tab-content">
                            <div id="collapseBillingOne" :class="billingTabPaneClass('johkuinvoice')" role="tabpanel">
                              <div class="panel-body">
                                <div class="form-group">
                                  <label for="pay_option1_bank">{{ _('Bank') }}</label>
                                  <input type="text" class="form-control" id="payOption1Bank" :placeholder="_('for example Nordea')" v-model="settings.pay_option1_bank" />
                                </div>
                                <div class="form-group">
                                  <label for="pay_option1_iban">{{ _('IBAN') }}</label>
                                  <input type="text" class="form-control" id="payOption1Iban" :placeholder="_('for example FI1234567890123456')" v-model="settings.pay_option1_iban" />
                                </div>
                                <div class="form-group">
                                  <label for="pay_option1_bic">{{ _('BIC') }}</label>
                                  <input type="text" class="form-control" id="payOption1Bic" :placeholder="_('for example NDEAFIHH')" v-model="settings.pay_option1_bic" />
                                </div>
                              </div>
                            </div>

                            <div id="billingCollapseTwo" :class="billingTabPaneClass('ropoinvoice')" role="tabpanel">
                              <div class="panel-body">
                                <div class="form-group">
                                  <label for="pay_option7_trustid">{{ _('Ropo Id') }}</label>
                                  <input type="text" class="form-control" id="payOption7TrustId" :placeholder="_('Enter your Ropo id')" v-model="settings.pay_option7_trustid" />
                                </div>
                                <div class="form-group">
                                  <label for="pay_option7_trustapikey">{{ _('Ropo API Key') }}</label>
                                  <input type="text" class="form-control" id="payOption6TrustApiKey" :placeholder="_('Enter your Ropo API key')" v-model="settings.pay_option7_trustapikey" />
                                </div>
                                <div class="form-group">
                                  <label for="pay_option7_trustservicecode">{{ _('Service code') }}</label>
                                  <input type="text" class="form-control" id="payOption7TrustServiceCode" :placeholder="_('Enter your Ropo Service Code')" v-model="settings.pay_option7_trustservicecode" />
                                </div>
                                <div class="form-group" v-if="isNetvisorConfigured">
                                  <label for="pay_option7_netvisoraccount">{{ _('Netvisor account') }}</label>
                                  <div class="input-group">
                                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option7_netvisoraccount" />
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option7_netvisoraccount')">{{ _('Select') }}</button>
                                    </span>
                                  </div>
                                </div>
                                <div class="form-group" v-if="isBrioxConfigured">
                                  <label>{{ _('Briox payment method') }}</label>
                                  <div class="input-group">
                                    <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option7_brioxpaymentmethod)" />
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option7_brioxpaymentmethod')">{{ _('Select') }}</button>
                                    </span>
                                  </div>
                                </div>
                                <div class="form-group" v-if="isNocfoConfigured">
                                  <label>{{ _('NoCFO account') }}</label>
                                  <div class="input-group">
                                    <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option7_nocfoaccount" />
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option7_nocfoaccount')">{{ _('Select') }}</button>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                      
                            <div id="billingCollapseThree" :class="billingTabPaneClass('netvisorinvoice')" role="tabpanel">
                              <div class="panel-body">
                                <div class="form-group">
                                  <label for="netvisor_customerid">{{ _('Netvisor Customer ID') }}</label>
                                  <input type="text" class="form-control" id="netvisorCustomerId" :placeholder="_('Enter your Netvisor Customer ID')" v-model="settings.netvisor_customerid" />
                                </div>
                                <div class="form-group">
                                  <label for="netvisor_organizationid">{{ _('Netvisor Organization ID') }}</label>
                                  <input type="text" class="form-control" id="netvisorOrganizationId" :placeholder="_('Enter your Netvisor Organization ID')" v-model="settings.netvisor_organizationid" />
                                </div>
                                <div class="form-group">
                                  <label for="netvisor_userkey">{{ _('Netvisor User Key') }}</label>
                                  <input type="text" class="form-control" id="netvisorUserKey" :placeholder="_('Enter your Netvisor User Key')" v-model="settings.netvisor_userkey" />
                                </div>
                                <div class="form-group" v-if="isNetvisorConfigured">
                                  <label for="pay_option13_netvisoraccount">{{ _('Netvisor account') }}</label>
                                  <div class="input-group">
                                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option13_netvisoraccount" />
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option13_netvisoraccount')">{{ _('Select') }}</button>
                                    </span>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label>{{ _('Initial data synchronization') }}</label>
                                  <div class="input-group">
                                    <button type="button" class="btn btn-info" id="netvisorSyncButton" v-on:click="netvisorSync">{{ _('Synchronize') }}</button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div id="billingCollapseFour" v-if="isBrioxSetupVisible" :class="billingTabPaneClass('brioxinvoice')" role="tabpanel">
                              <div class="panel-body">
                                <div class="form-group">
                                  <label for="briox_accountid">{{ _('Briox Account ID') }}</label>
                                  <input type="text" class="form-control" id="brioxAccountId" :placeholder="_('Enter your Briox Account ID')" v-model="settings.briox_accountid" />
                                </div>
                                <div class="form-group">
                                  <label for="briox_apptoken">{{ _('Briox Authentication Token') }}</label>
                                  <input type="text" class="form-control" id="brioxAppToken" :placeholder="_('Generate in Briox Admin → Users → Authentication token')" v-model="settings.briox_apptoken" />
                                </div>
                                <div class="form-group" v-if="isBrioxConfigured">
                                  <label for="pay_option20_brioxpaymentmethod">{{ _('Briox payment method') }}</label>
                                  <div class="input-group">
                                    <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option20_brioxpaymentmethod)" />
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option20_brioxpaymentmethod')">{{ _('Select') }}</button>
                                    </span>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label>{{ _('Initial data synchronization') }}</label>
                                  <div class="input-group">
                                    <button type="button" class="btn btn-info" id="brioxSyncButton" v-on:click="brioxSync">{{ _('Synchronize') }}</button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div id="billingCollapseFive" v-if="isNocfoSetupVisible" :class="billingTabPaneClass('nocfoinvoice')" role="tabpanel">
                              <div class="panel-body">
                                <div class="form-group">
                                  <label for="nocfo_token">{{ _('Personal Access Token') }}</label>
                                  <input type="text" class="form-control" id="nocfoToken" :placeholder="_('Enter your NoCFO Personal Access Token')" v-model="settings.nocfo_token" />
                                </div>
                                <div class="form-group">
                                  <label for="nocfo_business_slug">{{ _('Business slug') }}</label>
                                  <input type="text" class="form-control" id="nocfoBusinessSlug" :placeholder="_('Enter your NoCFO business slug')" v-model="settings.nocfo_business_slug" />
                                </div>
                                <div class="form-group" v-if="isSuperAdmin">
                                  <label for="nocfo_base_url">{{ _('API base URL') }}</label>
                                  <input type="text" class="form-control" id="nocfoBaseUrl" :placeholder="_('Leave empty for production')" v-model="settings.nocfo_base_url" />
                                </div>
                                <div class="form-group" v-if="isNocfoConfigured">
                                  <label for="pay_option21_nocfoaccount">{{ _('NoCFO account') }}</label>
                                  <div class="input-group">
                                    <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option21_nocfoaccount" />
                                    <span class="input-group-btn">
                                      <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option21_nocfoaccount')">{{ _('Select') }}</button>
                                    </span>
                                  </div>
                                </div>
                                <div class="form-group">
                                  <label>{{ _('Initial data synchronization') }}</label>
                                  <div class="input-group">
                                    <button type="button" class="btn btn-info" id="nocfoSyncButton" v-on:click="nocfoSync">{{ _('Synchronize') }}</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                        
                          </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option1" true-value="1" false-value="0" :disabled="isInvoiceSet ? false : true"/>
                              <span>{{ _('Selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <!-- Advance payment only visible for existing users -->
                  <div :class="paymentPanelClass(2)" v-if="parseInt(settings.pay_option2)">
                    <div class="panel-heading" role="tab" id="headingTwo">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseTwo" v-on:click="togglePanel('two')">
                        <span class="title-text">{{  _('Advance payment (bank transfer)') }}</span>
                        <span class="label label-info" v-if="isBankTransferSet && parseInt(settings.pay_option2)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseTwo" class="panel-collapse" role="tabpanel" aria-labelledby="headingTwo" v-if="isPanelOpen('two')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option2_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption2Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option2_title" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option2_bank">{{ _('Bank') }}</label>
                            <input type="text" class="form-control" id="payOption2Bank" :placeholder="_('for example Nordea')" v-model="settings.pay_option2_bank" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option2_iban">{{ _('IBAN') }}</label>
                            <input type="text" class="form-control" id="payOption2Iban" :placeholder="_('for example FI1234567890123456')" v-model="settings.pay_option2_iban" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option2_bic">{{ _('BIC') }}</label>
                            <input type="text" class="form-control" id="payOption2Bic" :placeholder="_('for example NDEAFIHH')" v-model="settings.pay_option2_bic" />
                          </div>
                          <div class="form-group">
                            <label for="pay_option2_extraeur">{{ _('Surcharge') }} ({{ settings.currency }})</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption2ExtraEur" :placeholder="_('Enter the surcharge amount')" v-model="settings.pay_option2_extraeur" />
                              <div class="input-group-addon">{{ settings.currency }}</div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="pay_option2_extraeur">{{ _('Surcharge') }} (%)</label>
                            <div class="input-group">
                              <input type="text" class="form-control" id="payOption2ExtraPerc" :placeholder="_('Enter the surcharge percentage')" v-model="settings.pay_option2_extraperc" />
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="pay_option2_netvisoraccount">{{ _('Netvisor account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_option2_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_option2_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isBrioxConfigured">
                            <label>{{ _('Briox payment method') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_option2_brioxpaymentmethod)" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_option2_brioxpaymentmethod')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNocfoConfigured">
                            <label>{{ _('NoCFO account') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="settings.pay_option2_nocfoaccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_option2_nocfoaccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option2" true-value="1" false-value="0" :disabled="isBankTransferSet ? false : true"/>
                              <span>{{ _('Selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>

                <h4>{{ _('Open orders') }}</h4>
                <div class="panel-group flex-panel" id="accordionOpens" role="tablist" aria-multiselectable="true">
                  <div :class="paymentPanelClass(11)">
                    <div class="panel-heading" role="tab" id="headingEleven">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseEleven" v-on:click="togglePanel('eleven')">
                        <span class="title-text">{{ _('Open order') }}</span>
                        <span class="label label-info" v-if="parseInt(settings.pay_option11)"><i class="fa fa-fw fa-globe-pointer"></i><span class="hidden-xs"> {{ _('Online') }}</span></span>
                        <span class="label label-success"><i class="fa fa-fw fa-shopping-basket"></i><span class="hidden-xs"> {{_('In-store') }}</span></span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseEleven" class="panel-collapse" role="tabpanel" aria-labelledby="headingEleven" v-if="isPanelOpen('eleven')">
                        <div class="panel-body">
                          <div class="form-group languageversioned">
                            <label for="pay_option11_title">{{ _('Title') }}</label>
                            <input type="text" class="form-control" id="payOption11Title" :placeholder="_('Enter the payment method\'s visible name')" v-model="settings.pay_option11_title" />
                          </div>
                          <div class="form-group languageversioned">
                            <label for="pay_option11_action">{{ _('Action button text') }}</label>
                            <input type="text" class="form-control" id="payOption11Action" :placeholder="_('Enter the payment method\'s action button text')" v-model="settings.pay_option11_action" />
                          </div>
                          <div class="form-group languageversioned">
                            <label for="pay_option11_description">{{ _('Description') }}</label>
                            <textarea class="form-control" id="payOption11Description" :placeholder="_('Enter the payment method\'s description')" v-model="settings.pay_option11_description"></textarea>
                          </div>
                          <p>{{ _('This payment method enables your customers to create open orders which you will be able to modify and complete.') }}</p>
                        </div>
                        <div class="panel-footer">
                          <div class="form-group">
                            <label>
                              <input type="checkbox" v-model="settings.pay_option11" true-value="1" false-value="0"/>
                              <span>{{ _('Selectable for online orders')}}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                  
                <div class="panel-group flex-panel" id="accordionOther" role="tablist" aria-multiselectable="true">                 
                  <div class="panel panel-info" v-if="isNetvisorConfigured || isBrioxConfigured || isNocfoConfigured">
                    <div class="panel-heading" role="tab" id="headingOthers">
                      <h4 class="panel-title">
                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="javascript:;" aria-expanded="false" aria-controls="collapseOthers" v-on:click="togglePanel('others')">
                        <span class="title-text">{{ _('Other payment methods') }}</span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="collapseOthers" class="panel-collapse" role="tabpanel" aria-labelledby="headingOthers" v-if="isPanelOpen('others')">
                        <div class="panel-body">
                          <h3 v-if="isNetvisorConfigured">{{ _('Netvisor accounts') }}</h3>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="cash_netvisoraccount">{{ _('Cash') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_optioncash_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_optioncash_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="cash_netvisoraccount">{{ _('Card') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_optioncard_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_optioncard_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="virtualcard_netvisoraccount">{{ _('Virtual card') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_optionvirtualcard_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_optionvirtualcard_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="cash_netvisoraccount">{{ _('Voucher') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_optionvoucher_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_optionvoucher_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="false">
                            <label for="cash_netvisoraccount">{{ _('Gift card') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_optiongiftcard_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_optiongiftcard_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured">
                            <label for="bokun_netvisoraccount">{{ _('Bókun') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_optionbokun_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_optionbokun_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNetvisorConfigured && isGygFeatureEnabled">
                            <label for="gyg_netvisoraccount">{{ _('GetYourGuide') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control netvisor-account" disabled="disabled" :value="settings.pay_optiongyg_netvisoraccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="netvisorAccountDialog(settings, 'pay_optiongyg_netvisoraccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <h3 v-if="isBrioxConfigured">{{ _('Briox payment methods') }}</h3>
                          <div class="form-group" v-if="isBrioxConfigured">
                            <label>{{ _('Cash') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_optioncash_brioxpaymentmethod)" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_optioncash_brioxpaymentmethod')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isBrioxConfigured">
                            <label>{{ _('Card') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_optioncard_brioxpaymentmethod)" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_optioncard_brioxpaymentmethod')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isBrioxConfigured">
                            <label>{{ _('Voucher') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_optionvoucher_brioxpaymentmethod)" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_optionvoucher_brioxpaymentmethod')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isBrioxConfigured">
                            <label>{{ _('Bókun') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_optionbokun_brioxpaymentmethod)" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_optionbokun_brioxpaymentmethod')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isBrioxConfigured && isGygFeatureEnabled">
                            <label>{{ _('GetYourGuide') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="brioxPaymentMethodTitle(settings.pay_optiongyg_brioxpaymentmethod)" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="brioxPaymentMethodDialog(settings, 'pay_optiongyg_brioxpaymentmethod')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <h3 v-if="isNocfoConfigured">{{ _('NoCFO accounts') }}</h3>
                          <div class="form-group" v-if="isNocfoConfigured">
                            <label>{{ _('Cash') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="settings.pay_optioncash_nocfoaccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_optioncash_nocfoaccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNocfoConfigured">
                            <label>{{ _('Card') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="settings.pay_optioncard_nocfoaccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_optioncard_nocfoaccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNocfoConfigured">
                            <label>{{ _('Voucher') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="settings.pay_optionvoucher_nocfoaccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_optionvoucher_nocfoaccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNocfoConfigured">
                            <label>{{ _('Bókun') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="settings.pay_optionbokun_nocfoaccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_optionbokun_nocfoaccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                          <div class="form-group" v-if="isNocfoConfigured && isGygFeatureEnabled">
                            <label>{{ _('GetYourGuide') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" disabled="disabled" :value="settings.pay_optiongyg_nocfoaccount" />
                              <span class="input-group-btn">
                                <button type="button" class="btn btn-info" v-on:click="nocfoAccountDialog(settings, 'pay_optiongyg_nocfoaccount')">{{ _('Select') }}</button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 rightcol" v-if="!hasFocus">
                <h3>{{ _('General payment settings') }}</h3>
                <div class="form-group">
                  <label for="interest">{{ _('Interest rate') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="interest" name="interest" :placeholder="_('Enter interest rate percentage')" v-model="settings.interest" />
                    <div class="input-group-addon"> %</div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="orderCounter">{{ _('Next order number') }}</label>
                  <input type="number" data-android-inputmode="decimal" class="form-control" name="orderCounter" id="orderCounter" placeholder="" v-model="settings.orderCounter" />
                </div>
                <div class="form-group">
                  <label for="billCounter">{{ _('Next bill number') }}</label>
                  <input type="number" data-android-inputmode="decimal" class="form-control" name="billCounter" id="billCounter" placeholder="" v-model="settings.billCounter" />
                </div>
                <div class="form-group">
                  <label for="selectedCurrency">{{ _('Currency') }}</label>
                  <select id="selectedCurrency" name="currency" class="form-control" v-model="settings.currency">
                    <option v-for="currency in priorityCurrencyOptions" :value="currency.id">{{ currency.name }}</option>
                    <option disabled="disabled">────────────</option>
                    <option v-for="currency in currencyOptions" :value="currency.id">{{ currency.name }}</option>
                    <option disabled="disabled">────────────</option>
                    <option v-for="currency in lastCurrencyOptions" :value="currency.id">{{ currency.name }}</option>
                  </select>
                </div>
                <h3>{{ _('Available VAT percentages') }}</h3>
                <table class="table table-striped vatrows sortable" data-search="vat-percentages">
                  <thead>
                    <tr>
                      <th>{{ _('Percentage') }}</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <draggable v-model="vats" tag="tbody" draggable=".vatrow" :delay="100" :delayOnTouchOnly="true">
                    <tr class="vatrow" v-for="vat in vats">
                      <td class="sortable">{{ formatVat(vat, numberFormat) }} %</td>
                      <td><a href="javascript:;" class="pull-right" v-on:click="removeVat(vat)" v-if="parseFloat(vat) > 0"><i class="fa fa-fw fa-close"></i></a></td>
                    </tr>
                  </draggable>
                </table>
                <div class="form-inline">
                  <button type="button" class="addvat btn btn-success" id="addVatButton" v-on:click="selectVat"><i class="fa fa-fw fa-plus"></i> {{ _('Add VAT percentage') }}</button>
                </div>
              </div>
            </div>
            <hr/>
            <div class="row" v-if="isFeatureEnabled('calendarpricing') || isFeatureEnabled('activitypricing')">
              <div class="col-lg-6 col-sm-8 leftcol">
                <div class="form-group">
                  <h3>{{ _('Default pricing engine') }}</h3>
                  <select class="form-control" v-model="settings.default_pricing_engine">
                    <option value="pricerow">{{ _('Price rows') }}</option>
                    <option value="calendar">{{ _('Price calendar') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-sm-4 rightcol">
                <p>{{ _('Used only when creating a new product. Existing products keep their current pricing engine.') }}</p>
              </div>
            </div>
            <hr v-if="isFeatureEnabled('calendarpricing') || isFeatureEnabled('activitypricing')"/>
            <div class="row">
              <div class="col-lg-6 col-sm-8 leftcol">
                <div class="form-group">
                  <h3>{{ _('Price tiers') }}</h3>
                </div>
                <table class="table table-striped pricetierrows sortable" data-search="price-tiers">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                      <th v-if="isFeatureEnabled('activitypricing')">{{ _('Age') }}</th>
                      <th v-if="isGygFeatureEnabled">{{ _('Traveller category') }}</th>
                      <th><span v-if="false">{{ _('Products') }}</span></th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <draggable v-model="settings.ownPricetier" tag="tbody" draggable=".pricetierrow" :delay="100" :delayOnTouchOnly="true">
                    <tr class="pricetierrow" v-for="pricetier in settings.ownPricetier" style="cursor: pointer">
                      <td class="sortable" v-on:click="modifyPricetierDialog(pricetier)">{{ pricetier.name }}<template v-if="isFeatureEnabled('activitypricing') && pricetierRuleSummary(pricetier)"><br /><small class="text-muted">{{ pricetierRuleSummary(pricetier) }}</small></template></td>
                      <td class="sortable" v-if="isFeatureEnabled('activitypricing')" v-on:click="modifyPricetierDialog(pricetier)">{{ formatPricetierAgeRange(pricetier) }}</td>
                      <td class="sortable" v-if="isGygFeatureEnabled" v-on:click="modifyPricetierDialog(pricetier)"><span v-if="pricetier.category" class="label label-default">{{ gygCategoryLabel(pricetier.category) }}</span></td>
                      <td class="sortable">&nbsp;</td>
                      <td><a v-if="canRemovePricetier(pricetier)" href="javascript:;" class="pull-right" v-on:click.stop="removePricetier(pricetier)"><i class="fa fa-fw fa-close"></i></a></td>
                    </tr>
                  </draggable>
                </table>
                <div class="form-inline">
                  <button type="button" class="addpricetier btn btn-success" id="addPricetierButton" v-on:click="addPricetierDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Add price tier') }}</button>
                </div>
              </div>
              <div class="col-lg-6 col-sm-4 rightcol">
                <p>{{ _('Price tiers enable pricing based on a set of criteria such as customer age. In addition to the standard tiers you can also create custom ones, however they will only be available in Johku Storefront and Johku embed codes. Standard tiers can\'t be deleted but they can be renamed.') }}</p>
                <p>{{ _('You can change the order of price tiers by dragging a row to its desired position on the list.') }}</p>
              </div>
            </div>
            <hr/>
            <div class="row" v-if="!hasFocus">
              <div class="col-lg-6 col-sm-8 leftcol">
                <div class="form-group">
                  <h3>{{ _('Commissions') }}</h3>
                </div>
                <table class="table table-striped commissionrows" data-search="commissions">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                      <th>{{ _('Amount') }}</th>
                      <th>{{ _('VAT') }}</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody class="resourcerows" id="commissionsList">
                    <tr v-for="commission in commissions" v-on:click="selectCommission(commission)" style="cursor: pointer">
                      <td>{{ commission.name }}</td>
                      <td v-if="commissionType(commission) === '%'">{{ commission.price }} {{ commissionType(commission) }} </td>
                      <td v-else>{{ $filters.currency(commission.price) }}</td>
                      <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeCommission(commission)"><i class="fa fa-fw fa-close"></i></a> {{ commission.vat }} %</td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-inline">
                  <button type="button" class="addcommission btn btn-success" id="addCommissionButton" v-on:click="selectCommission"><i class="fa fa-fw fa-plus"></i> {{ _('Add commission') }}</button>
                </div>
              </div>
              <div class="col-lg-6 col-sm-4 rightcol">
                <p>{{ _('Commissions can be used in conjunction with reservable products. The commission is deducted from the product\'s price and it may have a different VAT than the product itself.') }}</p>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('paymentplans')" class="tab-pane active" id="paymentplans" v-if="isTabActive('paymentplans') && isFeatureEnabled('paymentplans')" key="paymentplans">
            <payment-plans-list :embedded="true" />
          </div>
          <div v-bind="tabPanel('vouchers')" class="tab-pane active" id="vouchers" v-if="isTabActive('vouchers')" key="vouchers">
            <div class="row">
              <div class="col-xs-6">
                <h3>{{ _('Vouchers') }}</h3>
              </div>
              <div class="col-xs-6">
                <button type="button" class="btn btn-success pull-right new-voucher" v-on:click="addVoucherDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New voucher') }}</button>
              </div>
            </div>
            <Datatable :url="vouchersUrl" :options="vouchersTableOptions" ref="datatableVouchers" />
          </div>
          <div v-bind="tabPanel('deliverymethods')" class="tab-pane active" id="deliverymethods" v-if="isTabActive('deliverymethods') && !isFeatureEnabled('delivery2.0')" key="deliverymethods">
            <div class="row">
              <div class="col-lg-6 col-sm-8 leftcol">
                <div class="form-group">
                  <h3>{{ _('Delivery methods') }}</h3>
                </div>
                <table class="table table-striped deliveryrows">
                  <thead>
                    <tr>
                      <th>{{ _('ID') }}</th>
                      <th>{{ _('Name') }}</th>
                      <th>{{ _('Price') }}</th>
                      <th>{{ _('VAT') }}</th>
                    </tr>
                  </thead>
                  <tbody class="resourcerows" id="deliveryMethods">
                    <tr v-for="method in currDeliveryMethods" v-on:click="modifyDeliveryMethodDialog(method)">
                      <td>{{ parseInt(method.id) ? method.id : '' }}</td>
                      <td>{{ method.name }}</td>
                      <td>{{ $filters.currency(method.price) }}</td>
                      <td><a v-on:click.stop="removeDeliveryMethod(method)" href="javascript:;" class="pull-right"><i class="fa fa-fw fa-close"></i></a>{{ method.vat }} %</td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-inline">
                  <button type="button" class="adddelivery btn btn-success" id="addDeliveryMethodButton" v-on:click="addDeliveryMethodDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Add delivery method') }}</button>
                </div>
              </div>
              <div class="col-lg-6 col-sm-4 leftcol">
                <p>{{ _('Add all delivery methods that are available in your store to the adjacent list. You can then choose which of them are enabled on a product by product basis. Please note that each delivery method has a fixed price.') }}</p>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('languages')" class="tab-pane active" id="languages" v-if="isTabActive('languages')" key="languages">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Languages') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" data-search="ui-language">
                <h3>{{ _('User interface language') }}</h3>
                <p />
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="fi" value="fi_FI" v-model="settingsLocale" /> Suomi
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="en" value="en_US" v-model="settingsLocale" /> English
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="sv" value="sv_SE" v-model="settingsLocale" /> Svenska
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="de" value="de_DE" v-model="settingsLocale" /> Deutsch
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="it" value="it_IT" v-model="settingsLocale" /> Italiano
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="es" value="es_ES" v-model="settingsLocale" /> Español
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="fr" value="fr_FR" v-model="settingsLocale" /> Français
                  </label>
                </div>
                <div class="radio">
                  <label>
                    <input class="radio" type="radio" name="locale" rel="nb" value="nb_NO" v-model="settingsLocale" /> Norsk
                  </label>
                </div>
                <h3>{{ _('Default formats') }}</h3>
                <div class="form-group">
                  <h4>{{ _('Date format') }}</h4>
                  <select id="dateFormat" name="dateformat" class="form-control" v-model="settings.dateformat">
                    <option :value="null">{{ _('automatic') }}</option>
                    <option v-for="format in dateFormats" :value="format">{{ DateTime.fromISO('2034-12-31').toFormat(toLuxonFormat(format)) }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <h4>{{ _('Time format') }}</h4>
                  <select id="timeFormat" name="timeformat" class="form-control" v-model="settings.timeformat">
                    <option :value="null">{{ _('automatic') }}</option>
                    <option v-for="format in timeFormats" :value="format">{{ DateTime.fromISO('2023-12-31T23:59').toFormat(toLuxonFormat(format)) }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <h4>{{ _('Number format') }}</h4>
                  <select id="numberFormat" name="numberformat" class="form-control" v-model="settings.numberformat">
                    <option :value="null">{{ _('automatic') }}</option>
                    <option v-for="format in numberFormats" :value="format">{{ formatNumber(1234.56, format) }}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <h3>{{ _('Enabled content language versions') }}</h3>
                <p />
                <table width="100%" id="enabledLanguageVersions">
                  <tbody>
                    <tr>
                      <td></td>
                      <td align="center"><label>{{ _('Administration') }}</label></td>
                      <td align="center"><label>{{ _('Storefront') }}</label></td>
                    </tr>
                    <tr>
                      <td><label>Suomi</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="fi_FI" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="fi_FI" /></td>
                    </tr>
                    <tr>
                      <td><label>English</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="en_US" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="en_US" /></td>
                    </tr>
                    <tr>
                      <td><label>Svenska</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="sv_SE" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="sv_SE" /></td>
                    </tr>
                    <tr>
                      <td><label>Deutsch</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="de_DE" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="de_DE" /></td>
                    </tr>
                    <tr>
                      <td><label>Italiano</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="it_IT" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="it_IT" /></td>
                    </tr>
                    <tr>
                      <td><label>Español</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="es_ES" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="es_ES" /></td>
                    </tr>
                    <tr>
                      <td><label>Français</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="fr_FR" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="fr_FR" /></td>
                    </tr>
                    <tr>
                      <td><label>Norsk</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="nb_NO" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="nb_NO" /></td>
                    </tr>
                    <tr>
                      <td><label>русский</label></td>
                      <td align="center"><input type="checkbox" v-model="versions" value="ru_RU" /></td>
                      <td align="center"><input type="checkbox" v-model="storefrontversions" value="ru_RU" /></td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-group">
                  <h4>{{ _('Default version') }}</h4>
                  <p />
                  <select id="defaultVersion" name="defaultversion" class="form-control" v-model="settings.defaultversion">
                    <option value="fi_FI">Suomi</option>
                    <option value="en_US">English</option>
                    <option value="sv_SE">Svenska</option>
                    <option value="de_DE">Deutsch</option>
                    <option value="it_IT">Italiano</option>
                    <option value="es_ES">Español</option>
                    <option value="fr_FR">Français</option>
                    <option value="ru_RU">русский</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('tags')" class="tab-pane active" id="tags" v-if="isTabActive('tags')" key="tags">
            <div class="row">
              <div class="col-xs-6">
                <h3>{{ _('Tags') }}</h3>
              </div>
            </div>
            <div class="flex-row space-between">
              <div class="flex-row">
                <div class="list-filter-col">
                  <div class="input-group">
                    <input class="form-control" id="searchField" type="text" v-model="tagSearch" :placeholder="_('Keyword search')" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                    </span>
                  </div>
                </div>
                <div class="list-filter-col">
                  <select class="form-control" v-model="category">
                    <option value="">{{ _('All tags') }}</option>
                    <option value="product">{{ _('Product') }}</option>
                    <option value="category">{{ _('Category') }}</option>
                    <option value="seo">{{ _('SEO') }}</option>
                    <option value="order">{{ _('Order') }}</option>
                    <option value="admin">{{ _('Admin') }}</option>
                    <option value="delivery">{{ _('Delivery method') }}</option>
                  </select>
                </div>
              </div>
              <button class="newSelector btn btn-success addbutton" type="button" v-on:click="addTagDialog()"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
            </div>
            <Datatable :url="tagsUrl" :search="tagSearch" :type-filter="category" :options="tagsTableOptions" ref="datatableTags" v-on:data="tagsTableEvent" />
            <ShowLabelSettings data-search="show-labels" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" />
          </div>
          <div v-bind="tabPanel('users')" class="tab-pane active" id="users" v-if="isTabActive('users')" key="users">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('User management') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="list-group" id="userList">
                  <a class="list-group-item" v-for="user in users" v-on:click="modifyUserDialog(user)">
                    <h4 class="list-group-item-heading"><i :class="userClass(user)"></i>{{ user.name }}</h4>
                    <p class="list-group-item-text">{{ user.email }}</p>
                  </a>
                </div>
                <div class="form-inline">
                  <button type="button" class="adduser btn btn-success" id="addUserButton" v-on:click="addUserDialog"><i class="fa fa-fw fa-plus"></i> {{ _('Add user') }}</button>
                </div>
              </div>
              <div class="col-sm-6">
                <p>{{ _('Add any number of users who can access the shop management interface to the adjacent list.') }}</p>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-lg-6 col-sm-8 leftcol">
                <div class="form-group" data-search="inactivity-logout">
                  <h3>{{ _('Log out after inactivity') }}</h3>
                  <select class="form-control" v-model="posSessionIdleDays">
                    <option :value="7">{{ _('7 days') }}</option>
                    <option :value="30">{{ _('1 month') }}</option>
                    <option :value="90">{{ _('3 months') }}</option>
                    <option :value="180">{{ _('6 months') }}</option>
                    <option :value="365">{{ _('12 months') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 col-sm-4 rightcol">
                <p>{{ _('Users are logged out of the management interface when they haven\'t used it for this long. Keeping it open in a browser tab counts as use.') }}</p>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('other')" class="tab-pane active" id="other" v-if="isTabActive('other')" key="other">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Other settings') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6" data-search="automated-functions">
                <h3>{{ _('Automated functions') }}</h3>
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="settings.mark_processed" true-value="1" false-value="0" />{{ _('Automatically set order as "Processed" after reservation has ended.') }}
                  </label>
                </div>
                <div class="checkbox" data-search="after-sales">
                  <label>
                    <input type="checkbox" v-model="settings.send_aftersales" true-value="1" false-value="0" />{{ _('Automatically send an after sales message.') }}
                  </label>
                </div>
                <div class="form-inline">
                  {{ _('Wait') }} <input style="width: 80px; margin-left: 3px; margin-right: 3px" class="form-control" type="number" data-android-inputmode="decimal" v-model="settings.send_aftersales_delay" /> {{ _('hours before sending.') }}
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-6">
                <h3>{{ _('Google') }}</h3>
                <div class="form-group" data-search="google-calendar">
                  <label for="calendarauthcode">{{ _('Google Calendar key') }}</label>
                  <input class="form-control" v-model="settings.calendarauthcode" type="text" />
                  <p class="text-info"><i class="fa fa-fw fa-info"></i> {{ _('Optional, can be used to send reservations to Google Calendar.') }}</p>
                </div>
                <p>
                  {{ _('You can get Google Calendar key by signing in with Google') }}.
                  <a href="https://www.johku.fi/fi/tietosuoja" target="_blank" v-if="settingsLocale === 'fi_FI'">{{ _('Privacy policy') }}</a>
                  <a href="https://johku.fi/fi/privacy" target="_blank" v-else>{{ _('Privacy policy') }}</a>
                </p>
                <div>
                  <img src="/img/google/btn_google_signin_dark_normal_web.png" alt="Sign In with Google" v-on:click="login" style="cursor:pointer" v-if="!googleSignIn && isReady" />
                </div>
                <!--
                <div v-if="isFeatureEnabled('calendar2.0')">
                  <img src="/img/google/btn_google_signin_dark_normal_web.png" alt="Sign In with Google" v-on:click="getCalendarToken" style="cursor:pointer" v-if="!googleSignIn" />
                  <button class="btn btn-primary" v-on:click="getOfflineKey" v-if="googleSignIn">{{ _('Get calendar key') }}</button>
                </div>
                <div v-else>
                  <img src="/img/google/btn_google_signin_dark_normal_web.png" alt="Sign In with Google" v-on:click="getCalendarToken" style="cursor:pointer" />
                </div>
                -->
                <div v-if="isFeatureEnabled('statisticsfinland')" data-search="statistics-finland">
                  <hr/>
                  <h3>{{ _('Statistics Finland') }}</h3>
                  <div class="form-group">
                    <label for="statisticsidentifier">{{ _('Statistics Finland Identifier') }}</label>
                    <input class="form-control" v-model="settings.statisticsidentifier" name="statisticsidentifier" type="text" autocomplete="off" />
                  </div>
                  <div class="form-group">
                    <label for="statisticsusername">{{ _('Statistics Finland Username') }}</label>
                    <input class="form-control" v-model="settings.statisticsusername" name="statisticsusername" type="text" autocomplete="off" />
                  </div>
                  <div class="form-group">
                    <label for="statisticspassword">{{ _('Statistics Finland Password') }}</label>
                    <input class="form-control" v-model="settings.statisticspassword" name="statisticspassword" type="text" autocomplete="off" />
                  </div>
                  <button class="btn btn-primary" v-on:click="openStatisticsFinlandDialog">{{ _('Set open days') }}</button>
                  <button class="btn btn-info" v-on:click="generateTestStatisticsFinlandData()" v-if="false">{{ _('Generate test data') }}</button>
                </div>
              </div>
              <div class="col-sm-6">
                <h3>{{ _('Customers') }}</h3>
                <div class="form-group">
                  <label for="customertype">{{ _('Default customer type') }}</label>
                  <select class="form-control" id="customerType" v-model="settings.customertype">
                    <option value="defaultprivate">{{ _('Private customer') }}</option>
                    <option value="defaultbusiness">{{ _('Company or organization') }}</option>
                    <option value="onlyprivate">{{ _('Private customer only') }}</option>
                    <option value="onlybusiness">{{ _('Company or organization only') }}</option>
                  </select>
                  <p class="text-info"><i class="fa fa-fw fa-info"></i> {{ _('Default customer type for online orders.') }}</p>
                </div>
                <h3>{{ _('Basket') }}</h3>
                <div class="form-group" data-search="reservation-timeout">
                  <label for="reservationtimeout">{{ _('Reservation timeout') }}</label>
                  <div class="input-group">
                    <input class="form-control" v-model="reservationTimeout" type="number" data-android-inputmode="decimal" />
                    <div class="input-group-addon">{{ _('min') }}</div>
                  </div>
                  <p class="text-info"><i class="fa fa-fw fa-info"></i> {{ _('How long reservations are kept in the basket before they expire.') }}</p>
                </div>
                <div class="form-group" data-search="disable-basket">
                  <label>
                    <input type="checkbox" v-model="settings.disablebasket" true-value="1" false-value="0" /> {{ _('Disable basket') }}
                  </label>
                </div>
                <template v-if="settings.igloohome_apikey">
                  <h3>{{ _('Igloohome') }}</h3>
                  <div class="form-group" data-search="igloohome">
                    <label for="igloohome_apikey">{{ _('Igloohome API key') }}</label>
                    <input class="form-control" v-model="settings.igloohome_apikey" type="text" />
                    <p class="text-info"><i class="fa fa-fw fa-info"></i> {{ _('Optional, can be used to control Igloohome lock boxes.') }}</p>
                  </div>
                </template>
                <template v-if="settings.ratna_url || settings.ratna_username || settings.ratna_password">
                  <h3>{{ _('Ratna') }}</h3>
                  <div class="form-group" data-search="ratna">
                    <label for="ratna_url">{{ _('Ratna API URL') }}</label>
                    <input class="form-control" v-model="settings.ratna_url" type="text" />
                    <p class="text-info"><i class="fa fa-fw fa-info"></i> {{ _('Optional, can be used to control Ratna locks.') }}</p>
                  </div>
                  <div class="form-group">
                    <label for="ratna_username">{{ _('Ratna user name') }}</label>
                    <input class="form-control" v-model="settings.ratna_username" type="text" />
                    <p class="text-info"><i class="fa fa-fw fa-info"></i> {{ _('Optional, can be used to control Ratna locks.') }}</p>
                  </div>
                  <div class="form-group">
                    <label for="ratna_password">{{ _('Ratna password') }}</label>
                    <input class="form-control" v-model="settings.ratna_password" type="text" />
                    <p class="text-info"><i class="fa fa-fw fa-info"></i> {{ _('Optional, can be used to control Ratna locks.') }}</p>
                  </div>
                  <div class="form-group">
                    <label for="ratna_password">{{ _('Ratna apartments') }}</label>
                    <draggable-multi-selector v-model="ratnaApartments" :items="ratnaApartments" itemProperty="name" :selectorTitle="_('Link a Loyalty card')" />
                    <button class="btn btn-success" type="button" v-on:click="addRatnaApartmentDialog">{{ _('Add apartment') }}</button>
                  </div>
                </template>
              </div>
            </div>
            <template v-if="false">
              <hr />
              <div class="row">
                <div class="col-xs-12">
                  <h3>{{ _('Legacy storefront') }}</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label>
                    <input type="checkbox" v-model="settings.legacystorefront" true-value="1" false-value="0" /> {{ _('Use legacy storefront') }}
                  </label>
                </div>
              </div>
            </template>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar flex-row">
      <div class="flex-row align-right">
        <button class="btn btn-default" v-on:click="close" v-if="showCloseButton"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
        <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import modals from '~/lib/modals'
import currencies from '~/lib/currencies'
import formats from '~/lib/formats'
import netvisor from '~/lib/netvisor'
import briox from '~/lib/briox'
import nocfo from '~/lib/nocfo'
import permissions from '~/lib/permissions'
import pricetierrules from '~/lib/pricetierrules'
import settingseditors from '~/lib/settingseditors'
import settingshelpers from '~/lib/settingshelpers'
import slidetransition from '~/lib/slidetransition'
import tags from '~/lib/tags'
import { MobilepayOnboarding, UserDetails, DraggableMultiSelector, Datatable, VismaBoarding, StatisticsFinlandOpenDays, PaymentPlansList, ShowLabelSettings } from '#components'
import { DateTime } from 'luxon'
import formatters from '~/lib/formatters'
import { mapGetters } from 'vuex'
import { useCodeClient } from "vue3-google-signin"

export default {
  setup () {
    const calendarAuthCode = ref(null)
    const instance = getCurrentInstance()
    const handleGoogleSignInSuccess = (response) => {
      calendarAuthCode.value = response.code
    }
    const handleGoogleSignInError = (error) => {
      if (instance && instance.proxy) {
        instance.proxy.showError(instance.proxy._('An error occurred when trying to get Google Calendar key'))
      } 
      console.log(error)
    }
    const config = useRuntimeConfig().public
    // const googleCalendarClientId = config.googlecalendar.clientId
    const { login, isReady } = useCodeClient({
      onSuccess: handleGoogleSignInSuccess,
      onError: handleGoogleSignInError,
      // client_id: googleCalendarClientId,
      scope: 'https://www.googleapis.com/auth/calendar',
      access_type: 'offline'
    })
    return {
      login,
      isReady,
      calendarAuthCode
    }
  },
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      showPayPalSandBox: false,
      customLocale: null,
      activeTab: 'paymentmethods',
      activeBillingTab: 'johkuinvoice',
      users: [],
      mobilepayOnboardingStatuses: [],
      checkingMobilepayOnboardingStatuses: false,
      vivaOnboardingStatuses: [],
      checkingVivaOnboardingStatus: false,
      mobilepayRecurringMsn: null,
      checkingMobilepayRecurring: false,
      creatingPaytrailAccount: false,
      vouchersTableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('Value'),
          field: 'value',
          widthGrow: 2,
          formatter: this.numberFormatter()
        },
        {
          title: _('Value card'),
          field: 'valuecard',
          widthGrow: 2,
          formatter: this.yesNoFormatter()
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const name = row.getCell('name').getValue()
          $this.editVoucher(id, name)
        }
      },
      tagsTableOptions: {
        persistenceSuffix: 'settings',
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Title'),
          field: 'title',
          widthGrow: 4,
        },
        {
          title: _('Type'),
          field: 'category',
          widthGrow: 2,
          formatter: this.tagTypeFormatter()
        },
        {
          title: _('Language'),
          field: 'locale',
          widthGrow: 2,
          formatter: this.tagLanguageFormatter()
        }
        ],
        initialSort: [{
          column: 'title',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const title = row.getCell('title').getValue()
          $this.editTag(id, title)
        }
      },
      tagSearch: '',
      category: '',
      googleSignIn: false,
      panelOpen: {},
      DateTime: DateTime
    }
  },
  props: {
    focus: String,
    embedded: {
      type: Boolean,
      default: false
    }
  },
  mixins: [components, currencies, formats, formatters, modals, netvisor, briox, nocfo, permissions, pricetierrules, settingseditors, settingshelpers, slidetransition, tags],
  computed: {
    billingTabList () {
      return [
        { id: 'johkuinvoice', label: this._('Johku Invoice (PDF)') },
        { id: 'ropoinvoice', label: this._('Ropo') },
        { id: 'netvisorinvoice', label: this._('Netvisor') },
        { id: 'brioxinvoice', label: this._('Briox'), hidden: !this.isBrioxSetupVisible },
        { id: 'nocfoinvoice', label: this._('NoCFO'), hidden: !this.isNocfoSetupVisible }
      ]
    },
    tabList () {
      return this.editorTabs([
        { id: 'paymentmethods', label: this._('Paying') },
        { id: 'paymentplans', label: this._('Payment Plans'), hidden: !this.isFeatureEnabled('paymentplans') },
        { id: 'vouchers', label: this._('Vouchers') },
        { id: 'deliverymethods', label: this._('Delivery methods'), hidden: this.isFeatureEnabled('delivery2.0') },
        { id: 'languages', label: this._('Languages') },
        { id: 'tags', label: this._('Tags') },
        { id: 'users', label: this._('Management users') },
        { id: 'other', label: this._('Other') }
      ])
    },
    ...mapGetters(['numberFormat']),
    isGygFeatureEnabled () {
      return this.isFeatureEnabled('gyg') && this.isFeatureEnabled('activitypricing')
    },
    posSessionIdleDays: {
      get () {
        return parseInt(this.settings.pos_session_idle_days) || 180
      },
      set (value) {
        this.settings.pos_session_idle_days = value
      }
    },
    googleCalendarClientId () {
      const config = useRuntimeConfig().public
      return config.googlecalendar.clientId
    },
    isBankTransferSet () {
      return this.settings.pay_option2_bank && this.settings.pay_option2_iban && this.settings.pay_option2_bic
    },
    isInvoiceSet () {
      return this.settings.pay_option1_bank && this.settings.pay_option1_iban && this.settings.pay_option1_bic && this.settings.pay_option1_duedays && this.settings.pay_option1_noticedays
    },
    isRopoInvoiceSet () {
      return this.settings.pay_option7_trustid && this.settings.pay_option7_trustapikey && this.settings.pay_option7_trustservicecode
    },
    isNetvisorInvoiceSet () {
      return this.settings.netvisor_customerid && this.settings.netvisor_organizationid && this.settings.netvisor_userkey
    },
    isBrioxInvoiceSet () {
      return this.settings.briox_accountid && this.settings.briox_apptoken
    },
    isNocfoInvoiceSet () {
      return this.settings.nocfo_token && this.settings.nocfo_business_slug
    },
    isPaytrailLegacySet() {
      return this.settings.pay_option5_merchantid && this.settings.pay_option5_merchantcode
    },
    isPaytrailSet () {
      return this.settings.pay_option6_merchantid && this.settings.pay_option6_merchantcode
    },
    isPaytrailCompanyReady () {
      return !!(this.settings.companyname && this.settings.companyid && this.settings.companyaddress && this.settings.companyzip && this.settings.companycity && this.settings.companyemail && this.settings.companyphone)
    },
    isPayPalSet () {
      return this.settings.pay_option3_mode && this.settings.pay_option3_user && this.settings.pay_option3_pwd && this.settings.pay_option3_signature
    },
    isPayPalSandboxSet () {
      return this.settings.pay_option4_mode && this.settings.pay_option4_user && this.settings.pay_option4_pwd && this.settings.pay_option4_signature
    },
    isNetaxeptSet () {
      return this.settings.pay_option17_merchantid && this.settings.pay_option17_apitoken
    },
    isMobilePaySetOnline () {
      return this.isValidMobilepayMsn(this.settings.pay_option18_msn)
    },
    isMobilePaySetPos () {
      return this.isValidMobilepayMsn(this.settings.pay_option18_msn_pos)
    },
    mobilepayRecurringMsnInput: {
      get () {
        return this.mobilepayRecurringMsn !== null ? this.mobilepayRecurringMsn : (this.settings.pay_option18_msn_recurring || '')
      },
      set (value) {
        this.mobilepayRecurringMsn = value
      }
    },
    isMobilePaySet () {
      return this.isMobilePaySetOnline || this.isMobilePaySetPos
    },
    isVivaSet () {
      return this.settings.pay_option19_merchantid
    },
    // Latest application that is still waiting for registration or verification
    vivaOnboardingStatus () {
      return this.vivaOnboardingStatuses.find(status => !parseInt(status.completed)) || null
    },
    isStripeSet () {
      return this.settings.pay_option8_secretkey && this.settings.pay_option8_publishablekey && this.settings.pay_option8_signingsecret
    },
    isAlipaySet () {
      return this.settings.pay_option12_secretkey && this.settings.pay_option12_publishablekey && this.settings.pay_option12_signingsecret
    },
    isEpassiSet () {
      return this.settings.pay_option15_siteid && this.settings.pay_option15_mac
    },
    isEdenredSet () {
      return this.settings.pay_option9_privatekey && this.settings.pay_option9_apikey
    },
    isSaveButtonEnabled () {
      return !this.saving && !this.saved && !this.loading && !this.locked && !this.isDetailsColumnOpen
    },
    isDetailsColumnOpen () {
      return !!(this.columns && this.columns.find(c => c.identifier === 'details'))
    },
    hasFocus () {
      return !!this.focus
    },
    showCloseButton () {
      if (this.isModal || (this.componentTrail && this.componentTrail.length > 1)) {
        return true
      }
      return false
    },
    editorConfig () {
      return {
        toolbar:
          [
            ['Format', 'Bold', 'Italic', '-', 'NumberedList', 'BulletedList', 'Outdent', 'Indent', '-', 'Link', 'Unlink'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['Undo', 'Redo'],
            ['Source'],
            ['UIColor']
          ],
        height: '150px',
        language: this.shortLocale,
        allowedContent: true,
        extraPlugins: 'justify'
      }
    },
    isAdmin () {
      return true
    },
    allCurrencyOptions () {
      return Object.keys(this.currencyNames).map(c => { return { id: c, name: c + ' - ' + this._(this.currencyNames[c]) }})
    },
    currencyOptions () {
      return this.allCurrencyOptions.filter(c => !['EUR', 'USD', 'GBP', 'CRC'].includes(c.id))
    },
    priorityCurrencyOptions () {
      return this.allCurrencyOptions.filter(c => ['EUR', 'USD', 'GBP'].includes(c.id))
    },
    lastCurrencyOptions () {
      return this.allCurrencyOptions.filter(c => c.id === 'CRC')
    },
    reservationTimeout: {
      get () {
        return parseInt(this.settings.reservationtimeout, 10) / 60
      }, 
      set (newValue) {
        this.settings.reservationtimeout = parseInt(newValue) * 60
      }
    },
    ratnaApartments: {
      get () {
        return this.settings.ratna_apartments ? JSON.parse(this.settings.ratna_apartments) : []
      },
      set (newValue) {
        this.settings.ratna_apartments = JSON.stringify(newValue)
      }
    },
    vouchersUrl () {
      return this.baseDomain + this.shopId + '/vouchers.json?apikey=' + this.apiKey + '&rawformat=true'
    },
    tagsUrl () {
      return this.baseDomain + this.shopId + '/tags.json?apikey=' + this.apiKey
    }
  },
  methods: {
    toLuxonFormat (format) {
      return format.replace(/YYYY/g, 'yyyy').replace(/YY/g, 'yy').replace(/MMMM/g, 'LLLL').replace(/MMM/g, 'LLL').replace(/MM/g, 'LL').replace(/M/g, 'L').replace(/DD/g, 'dd').replace(/D/g, 'd')
    },
    billingTab(tab) {
      this.activeBillingTab = tab
    },
    isBillingTabActive(tab) {
      return this.activeBillingTab === tab
    },
    billingTabClass(tab) {
      return this.isBillingTabActive(tab) ? 'active' : ''
    },
    billingTabPaneClass(tab) {
      return String('tab-pane ' + this.billingTabClass(tab)).trim()
    },
    shopSettings (shopId) {
      return this.allSettings[shopId + '-' + this.version] || {} // Note: here we have to use version
    },
    isPaymentEnabled (index) {
      return this.settings && !!parseInt(this.settings['pay_option' + index])
    },
    isChannelEnabled (index) {
      return this.settings && !!parseInt(this.settings['channel_' + index])
    },
    paymentPanelClass (index) {
      return 'panel panel-' + (this.isPaymentEnabled(index) ? 'default' : 'default')
    },
    channelPanelClass (index) {
      return 'panel panel-' + (this.isChannelEnabled(index) ? 'info' : 'default')
    },
    userClass (user) {
      const l = parseInt(user.userlevel, 10)
      return 'fa fa-fw fa-' + (l === 10 ? 'bolt' : (l === 7 ? 'crown' : (l === 2 ? 'shopping-basket' : 'user'))) + ' fa-2x pull-right'
    },
    removeVat (vat) {
      this.vats = this.vats.filter(v => v !== vat)
    },
    selectVat () {
      this.showDialog({
        title: this._('VAT Percentage'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            handler: this.addVat
          }, 
        ],
        fields: [
          {
            title: this._('Percentage'),
            type: 'text',
            name: 'percentage',
            placeholder: this._('Enter the VAT percentage')
          }
        ]
      })
    },
    addVat (data) {
      if (data && data.percentage && data.percentage.replace) {
        data.percentage = data.percentage.replace(',', '.')
        if (!isNaN(parseFloat(data.percentage))) {
          if (!this.vats.find(v => parseFloat(v) === parseFloat(data.percentage))) {
            this.vats.push(parseFloat(data.percentage))
            this.removeVat(null) // This hack should not be needed to trigger an update on this.vats, but I guess if it works...?
          }
        }
      }
    },
    addPricetierDialog () {
      this.showDialog({
        title: this._('Price tier'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            handler: this.addPricetier
          }, 
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter the price tier\'s name'),
            localized: true
          },
          ...this.pricetierRuleFields(null)
        ]
      })
    },
    addPricetier (data) {
      if (data && data.name) {
        const pricetier = {
          id: 'new-' + DateTime.now().toUnixInteger(),
          name: data.name
        }
        if (this.isFeatureEnabled('activitypricing')) {
          this.applyPricetierRules(pricetier, data)
        }
        this.settings.ownPricetier.push(pricetier)
      }
    },
    // Activity pricing: ticket type rules of a shop price tier. Empty values mean no rule.
    pricetierRuleFields (pricetier) {
      if (!this.isFeatureEnabled('activitypricing')) {
        return []
      }
      const value = (name) => pricetier && pricetier[name] !== null && pricetier[name] !== undefined && pricetier[name] !== '' ? pricetier[name] : ''
      // Only saved tiers that don't require another tier themselves can be required
      const requirable = (this.settings.ownPricetier || []).filter(t => {
        return t.id && !(t.id.match && t.id.match(/^new/)) && (!pricetier || String(t.id) !== String(pricetier.id)) && !parseInt(t.requires_pricetier_id)
      })
      const isRequired = pricetier && (this.settings.ownPricetier || []).some(t => parseInt(t.requires_pricetier_id) === parseInt(pricetier.id))
      const fields = [
        {
          type: 'h4',
          text: this._('Ticket type rules')
        },
        {
          title: this._('Minimum age'),
          type: 'number',
          name: 'minage',
          defaultValue: value('minage')
        },
        {
          title: this._('Maximum age'),
          type: 'number',
          name: 'maxage',
          defaultValue: value('maxage')
        },
        {
          title: this._('Minimum quantity per booking'),
          type: 'number',
          name: 'mincount',
          defaultValue: value('mincount'),
          help: this._('The minimum applies only when this ticket type is selected.')
        },
        {
          title: this._('Maximum quantity per booking'),
          type: 'number',
          name: 'maxcount',
          defaultValue: value('maxcount')
        }
      ]
      if (requirable.length && !isRequired) {
        fields.push(
          {
            title: this._('Requires ticket type'),
            type: 'select',
            name: 'requires_pricetier_id',
            options: [
              { value: '', name: this._('No requirement') },
              ...requirable.map(t => { return { value: String(t.id), name: t.name } })
            ],
            defaultValue: value('requires_pricetier_id') !== '' ? String(pricetier.requires_pricetier_id) : '',
            help: this._('For example a child ticket can be sold only together with an adult ticket.')
          },
          {
            title: this._('Maximum per one required ticket'),
            type: 'number',
            name: 'requires_ratio',
            defaultValue: value('requires_ratio'),
            condition: 'requires_pricetier_id',
            conditionValue: requirable.map(t => String(t.id))
          }
        )
      }
      fields.push({
        title: this._('Maximum dependent tickets per one of this ticket type'),
        type: 'number',
        name: 'dependents_max',
        defaultValue: value('dependents_max'),
        help: this._('Combined maximum of the ticket types that require this ticket type, for example children and infants per adult.')
      })
      if (this.isGygFeatureEnabled) {
        fields.push({
          title: this._('Traveller category'),
          type: 'select',
          name: 'category',
          options: this.gygCategoryOptions(),
          // An empty category gets a suggestion from the age range, only as the initial value of the dialog
          defaultValue: value('category') !== '' ? pricetier.category : this.suggestGygCategory(pricetier),
          help: this._('The category of travellers in GetYourGuide.')
        })
      }
      return fields
    },
    applyPricetierRules (pricetier, data) {
      ['minage', 'maxage', 'mincount', 'maxcount', 'requires_pricetier_id', 'requires_ratio', 'dependents_max'].forEach(field => {
        if (!data || !data.hasOwnProperty(field)) {
          return
        }
        const value = data[field] === null || data[field] === undefined ? '' : String(data[field]).trim()
        pricetier[field] = value === '' ? null : value
      })
      if (!pricetier.requires_pricetier_id) {
        pricetier.requires_ratio = null
      }
      if (data && data.hasOwnProperty('category')) {
        pricetier.category = data.category || ''
      }
    },
    formatPricetierAgeRange (pricetier) {
      const hasMin = pricetier && pricetier.minage !== null && pricetier.minage !== undefined && pricetier.minage !== ''
      const hasMax = pricetier && pricetier.maxage !== null && pricetier.maxage !== undefined && pricetier.maxage !== ''
      if (hasMin && hasMax) {
        return pricetier.minage + '–' + pricetier.maxage
      }
      if (hasMin) {
        return pricetier.minage + '+'
      }
      if (hasMax) {
        return '0–' + pricetier.maxage
      }
      return ''
    },
    pricetierRuleSummary (pricetier) { // The age has a column of its own
      return this.pricetierRuleText(pricetier, this.settings.ownPricetier, false)
    },
    modifyPricetierDialog (pricetier) {
      let removeButton = []
      if (this.canRemovePricetier(pricetier)) {
        removeButton.push({
          title: this._('Delete'),
          class: 'danger',
          icon: 'trash',
          handler: (data) => {
            this.removePricetier(pricetier)
          }
        })
      }
      this.showDialog({
        title: this._('Price tier'),
        buttons: [
          ...removeButton,
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              if (pricetier.name) {
                pricetier.name = data.name
              }
              if (this.isFeatureEnabled('activitypricing')) {
                this.applyPricetierRules(pricetier, data)
              }
            }
          },
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            defaultValue: pricetier.name,
            placeholder: this._('Enter the price tier\'s name'),
            localized: true
          },
          ...this.pricetierRuleFields(pricetier)
        ]
      })
    },
    canRemovePricetier (pricetier) {
      if (!pricetier) {
        return false
      }
      if (!pricetier.id || parseInt(pricetier.id) > 3 || (pricetier.id.match && pricetier.id.match(/^new/))) {
        return true
      }
      return false
    },
    async removePricetier (pricetier) {
      let count
      try {
        count = await this.pricetierProductCount(pricetier)
      } catch (e) {
        this.showError(e)
        return
      }
      if (!count) {
        this.dropPricetier(pricetier)
        return
      }
      // A removed tier stays on its products and in their price rows, but the product editor no longer lists it,
      // and changing a product's tiers there drops it and its prices
      this.showDialog({
        title: this._('Remove the price tier?'),
        text: this._('%s products use this price tier. Remove it from those products first: the products keep charging its prices, but the product editor no longer shows it.').replace('%s', count),
        buttons: [
          { title: this._('Cancel'), icon: 'ban', handler: () => {} },
          { title: this._('Remove anyway'), class: 'danger', icon: 'trash', handler: () => this.dropPricetier(pricetier) }
        ]
      })
    },
    async pricetierProductCount (pricetier) {
      if (!pricetier.id || !/^\d+$/.test(String(pricetier.id))) { // Not saved yet
        return 0
      }
      const response = await axios.get(this.baseDomain + this.shopId + '/pricetiers.json?productcounts=true&apikey=' + this.apiKey)
      const tier = (response.data || []).find(t => String(t.id) === String(pricetier.id))
      return tier ? parseInt(tier.product_count, 10) || 0 : 0
    },
    dropPricetier (pricetier) {
      this.settings.ownPricetier = this.settings.ownPricetier.filter(t => t.id !== pricetier.id)
    },
    selectCommission (commission) {
      this.showDialog({
        title: this._('Commission'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              if (commission) {
                data.id = commission.id
              }
              this.addCommission(data)
            }
          }, 
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter the commission\'s name'),
            localized: true,
            defaultValue: commission.name
          },
          {
            title: this._('Amount'),
            type: 'text',
            name: 'price',
            placeholder: this._('Enter the commission\'s amount'),
            defaultValue: commission.price
          },
          {
            title: this._('Value added tax'),
            type: 'number',
            name: 'vat',
            placeholder: this._('Enter the commission\'s vat percentage'),
            addon: '%',
            defaultValue: commission.vat
          }
        ]
      })
    },
    addCommission (data) {
      if (data && data.name && data.price && data.vat) {
        let type = '0'
        if (data.price.match && data.price.match('%')) {
          type = '1'
        }
        if (data.id) {
          let index = this.commissions.findIndex(c => c.id == data.id)
          if (index !== -1) {
            this.commissions[index] = {
              id: data.id,
              name: data.name,
              price: parseFloat(data.price),
              vat: parseFloat(data.vat),
              type: type
            }
          }
        } else {
          this.commissions.push({
            id: 'new-' + DateTime.now().toUnixInteger(),
            name: data.name,
            price: parseFloat(data.price),
            vat: parseFloat(data.vat),
            type: type
          })
        }
      }
    },
    removeCommission (commission) {
      this.commissions = this.commissions.filter(t => t.id !== commission.id)
    },
    commissionType (commission) {
      if (parseInt(commission.type) === 1) {
        return '%'
      } else {
        return this.settings.currency
      }
    },
    getTagTitle(tag) {
      if (!tag || !tag.title) {
        return ''
      }
      const parts = tag.title.split(':::')
      return parts.pop()
    },
    modifyDeliveryMethodDialog (deliveryMethod) {
      this.showDialog({
        title: this._('Delivery method'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('OK'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'price', 'vat'],
            handler: (data) => {
              if (deliveryMethod && deliveryMethod.id && !deliveryMethod.id.startsWith('new-')) {
                data.id = deliveryMethod.id
              }
              this.saveDeliveryMethod(data)
            }
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter the delivery method\'s name'),
            defaultValue: deliveryMethod.name
          },
          {
            title: this._('Price inc. vat'),
            type: 'number',
            name: 'price',
            lang: this._('en_US'),
            placeholder: this._('Enter the delivery method\'s price'),
            defaultValue: deliveryMethod.price
          },
          {
            title: this._('Value added tax'),
            type: 'number',
            name: 'vat',
            placeholder: this._('Enter the delivery method\'s vat percentage'),
            defaultValue: deliveryMethod.vat,
            addon: '%'
          }
        ]
      })
    },
    addDeliveryMethodDialog () {
      return this.modifyDeliveryMethodDialog({
        id: 'new-' + DateTime.now().toUnixInteger()
      })
    },
    saveDeliveryMethod (deliveryMethod) {
      const index = this.currDeliveryMethods.findIndex(d => d.id === deliveryMethod.id)
      if (index !== -1) {
        this.currDeliveryMethods[index] = deliveryMethod
      } else {
        this.currDeliveryMethods.push(deliveryMethod)
      }
    },
    removeDeliveryMethod (deliveryMethod) {
      this.currDeliveryMethods = this.currDeliveryMethods.filter(d => d.id !== deliveryMethod.id)
    },
   /*
    getCalendarToken () {
      if (this.isFeatureEnabled('calendar2.0')) {
        const authInstance = gapi.auth2.getAuthInstance()
        authInstance.signIn().then(() => {
          this.showNotification(this._("Signed in. Click the 'Get calendar key' button to sync your calendar."))
        })
        .catch(error => {
          console.error(error)
          this.showError(this._('An error occurred when trying to get Google Calendar key'))
        })
      } else {
        window.open('https://accounts.google.com/o/oauth2/auth?response_type=code&client_id=555978401152-iir8r79cnblr0aj71nr8vp5deo7v5qhr.apps.googleusercontent.com&redirect_uri=urn%3Aietf%3Awg%3Aoauth%3A2.0%3Aoob&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcalendar')
      }
    },
    getOfflineKey () {
      if (!this.isFeatureEnabled('calendar2.0')) {
        return this.getCalendarToken()
      }
      const authInstance = gapi.auth2.getAuthInstance()
      authInstance.grantOfflineAccess().then(res => {
        this.settings.calendarauthcode = res.code
        this.showNotification(this._('Google Calendar key updated!'))
      })
    },
    initGapiClient () {
      const $this = this
      const config = useRuntimeConfig().public
      gapi.client.init({
        apiKey: config.googlecalendar.apiKey,
        discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
        clientId: config.googlecalendar.clientId,
        scope: 'https://www.googleapis.com/auth/calendar'
      }).then(function () {
        let authInstance = gapi.auth2.getAuthInstance()
        if (authInstance && authInstance.isSignedIn) {
          authInstance.isSignedIn.listen($this.updateSigninStatus)
          $this.updateSigninStatus(authInstance.isSignedIn.get())
        }
      })
    },
    updateSigninStatus (isSignedIn) {
      if (isSignedIn) {
        this.googleSignIn = true
      } else {
        this.googleSignIn = false
      }
    },
    gapiSignOut () {
      gapi.auth2.getAuthInstance().signOut()
    },
    */
    getStatus (s) {
      const _ = this._
      switch(parseInt(s, 10)) {
        case this.CHANNEL_UNPROCESSED:
          return _('Not processed');
        case this.CHANNEL_APPROVED:
          return _('Approved');
        case this.CHANNEL_REJECTED:
          return _('Rejected');
        case this.CHANNEL_ACCEPTED:
          return _('Accepted');
      }
    },
    loadUsers () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/users.json?excludeendusers=1&apikey=' + this.apiKey)
        } catch(e) {
          this.showError(this._('Error loading user data! Please try again.'))
          reject()
          return
        }
        this.users = response.data || []
        resolve(this.users)
      })
    },
    addUserDialog () {
      return this.modifyUserDialog({
        id: 'new-' + DateTime.now().toUnixInteger(),
        userlevel: '3'
      })
    },
    modifyUserDialog (user) {
      this.showModal('userdetails', UserDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          settings: this.settings,
          originalUser: user
        },
        events: {
          save: this.saveUser,
          remove: this.removeUser,
          reset: this.resetApiKey
        },
        backgroundEvents: {
          // Fired when a direct sign-in link is generated/rerolled - it replaces
          // the user's email with a placeholder, so refresh the underlying list
          // without closing the still-open editor.
          staticTokenChanged: this.loadUsers
        },
        handlers: {},
        width: 800
      })
    },
    async saveUser (data) {
      let response
      const newUser = !parseInt(data.id)
      const newStaticLinkUser = newUser && !!data.staticLoginLink
      try {
        if (!newUser) {
          response = await axios.put(this.baseDomain + this.shopId + '/users/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          data.id = null
          response = await axios.post(this.baseDomain + this.shopId + '/users.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        let msg = ''
        if (e.response && e.response.data && e.response.data.errorMessage) {
          msg = ' ' + e.response.data.errorMessage
        }
        if (newUser) {
          this.showError(this._('Creating the user failed!') + msg)
        } else {
          this.showError(this._('Editing the user failed!') + msg)
        }
        return
      }
      this.showNotification(this._('User saved!'))
      await this.loadUsers()
      if (newStaticLinkUser) {
        // The direct sign-in link is generated server-side as part of creation -
        // reopen the editor for the new user so the admin can see and copy it
        // right away, instead of having to find and reopen it manually.
        const createdUser = this.users.find(u => u.id == response.data)
        if (createdUser) {
          this.modifyUserDialog(createdUser)
        }
      }
    },
    async removeUser (data) {
      let response
      try {
        response = await axios.delete(this.baseDomain + this.shopId + '/users/' + data.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Deleting the user failed!'))
        return
      }
      this.loadUsers()
    },
    async resetApiKey (data) {
      let response
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/users/' + data.id + '.json?apikey=' + this.apiKey, { id: data.id })
      } catch(e) {
        this.showError(this._('Unable to reset the API key!'))
        return
      }
      await this.loadUsers()
      this.modifyUserDialog(this.users.find(u => u.id == data.id))
    },
    addRatnaApartmentDialog () {
      this.showDialog({
        title: this._('Add apartment'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Add'),
            class: 'success',
            icon: 'check',
            requiredFields: ['id', 'name'],
            handler: this.addRatnaApartment
          }
        ],
        fields: [
          {
            title: this._('ID'),
            type: 'text',
            name: 'id',
            placeholder: this._('Enter the apartment id'),
          },
          {
            title: this._('Name'),
            type: 'text',
            name: 'name',
            placeholder: this._('Enter a descriptive name for the apartment'),
          }
        ]
      })
    },
    addRatnaApartment (data) {
      this.ratnaApartments.push(data)
      this.ratnaApartments = this.ratnaApartments.filter(a => a !== null)
    },
    async save (payment) {
      this.saving = true
      if (this.versions.length === 0 || this.storefrontversions.length === 0) {
        this.saving = false
        return this.showError(this._('At least one content language version for administration and storefront must be selected.'))
      }
      let needsReload = false
      if (this.settingsLocale !== this.settings.locale) {
        needsReload = true
      }
      const data = this.getSaveData()
      data.pay_option18_extraeur = 0
      data.pay_option18_extraperc = 0
      data.reservationtimeout = this.reservationTimeout
      data.ownCommission = this.commissions
      data.ownDeliverymethod = this.currDeliveryMethods
      data.locale = this.settingsLocale
      data.version = this.version
      data.versions = this.versions
      data.storefrontversions = this.storefrontversions
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, data)
      } catch(e) {
        console.log(e)
        this.saving = false
        return this.showError(e)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.settings)
      try {
        this.$store.dispatch('reloadSettings')
      } catch (error) {
        return this.showError(error)
      }
      this.close()
      if (needsReload) {
        try {
          // Under /{shopId}/ so the shop-scoped session cookie is sent and auth is preserved.
          await $fetch('/' + this.shopId + '/locale', {
            method: 'POST',
            body: {
              locale: this.settingsLocale
            }
          })
        } catch (e) {
          console.log(e)
        }
        window.location.reload()
      }
    },
    addVoucherDialog () {
      this.showDialog({
        title: this._('New voucher'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name'],
            handler: this.addVoucher
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          }
        ]
      })
    },
    async addVoucher (data) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/vouchers.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.editVoucher(response.data, data.name)
    },
    editVoucher (id, name, activeTab, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'VoucherDetails',
        title: this._('Voucher') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          voucherId: id,
          activeTab
        },
        skipState
      })
    },
    reloadVouchersList () {
      if (this.$refs && this.$refs.datatableVouchers) {
        this.$refs.datatableVouchers.reload()
      }
    },
    reloadTagsList () {
      if (this.$refs && this.$refs.datatableTags) {
        this.$refs.datatableTags.reload()
      }
    },
    uncheckInvalidPaymentMethods () {
      if (!this.isBankTransferSet ) {
        this.settings.pay_option2 = 0
      }
      if (!this.isInvoiceSet) {
        this.settings.pay_option1 = 0
      }
      if (!this.isRopoInvoiceSet) {
        this.settings.pay_option7 = 0
      }
      if (!this.isNetvisorInvoiceSet) {
        this.settings.pay_option13 = 0
      }
      if (!this.isBrioxInvoiceSet) {
        this.settings.pay_option20 = 0
      }
      if (!this.isNocfoInvoiceSet) {
        this.settings.pay_option21 = 0
      }
      if (!this.isPaytrailLegacySet) {
        this.settings.pay_option5 = 0
      }
      if (!this.isPaytrailSet) {
        this.settings.pay_option6 = 0
      }
      if (!this.isPayPalSet) {
        this.settings.pay_option3 = 0
      }
      if (!this.isPayPalSandboxSet) {
        this.settings.pay_option4 = 0
      }
      if (!this.isVismaPaySet) {
        this.settings.pay_option9 = 0
      }
      if (!this.isStripeSet) {
        this.settings.pay_option8 = 0
      }
      if (!this.isAlipaySet) {
        this.settings.pay_option12 = 0
      }
      if (!this.isEpassiSet) {
        this.settings.pay_option15 = 0
      }
      if (!this.isNetaxeptSet) {
        this.settings.pay_option17 = 0
      }
      if (!this.isMobilePaySetOnline) {
        this.settings.pay_option18 = 0
      }
    },
    async loadStatisticsFinland () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/statisticsfinland.json?apikey=' + this.apiKey)
      } catch (e) {
        return
      }
      return response.data
    },
    async openStatisticsFinlandDialog () {
      let openDays = await this.loadStatisticsFinland()
      if (openDays) {
        this.showModal('statisticsfinland', StatisticsFinlandOpenDays, {
          props: {
            opendays: openDays
          },
          events: {
            setStatisticsFinlandOpenDays: this.setStatisticsFinlandOpenDays
          },
          width: 800
        })
      }
    },
    async setStatisticsFinlandOpenDays (data) {
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/statisticsfinland.json?apikey=' + this.apiKey, data)
      } catch (e) {}
      this.showNotification(this._('Open days set'))
    },
    async generateTestStatisticsFinlandData () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/statisticsfinland.json?apikey=' + this.apiKey, { start: "first day of june 00:00", end: "last day of june 00:00" })
      } catch (e) {}
      if (response && response.data) {
        this.showNotification('Test data generated to console')
        console.log(response.data)
      } else {
        this.showError('Failed to generate test data')
        console.error("No data returned")
      }
    },
    tagsTableEvent (data) { // This overrides the default event handler because the tags table has non-standard variables for search and type fields
      if (data) {
        if (data.filters) {
          for (let i = 0; i < data.filters.length; i++) {
            let f = data.filters[i]
            switch (f.field) {
              case 'search':
                if (!this.tagSearch) { // We need to check this, otherwise the search field will start "eating" characters
                  this.tagSearch = f.value
                }
                break
              case 'type':
              case 'displayedtype':
                this.category = f.value
                break
            }
          }
        }
      }
    },
    async createVivaAccountDialog () {
      this.showDialog({
        title: this._('Create Viva account'),
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Create'),
            icon: 'save',
            class: 'success',
            requiredFields: ['email'],
            handler: (data) => this.createVivaAccount(data)
          }
        ],
        fields: [
          {
            title: this._('Email'),
            type: 'text',
            name: 'email'
          },
        ]
      })
    },
    async createPaytrailAccount () {
      if (!this.isPaytrailCompanyReady || this.creatingPaytrailAccount) {
        return
      }
      this.creatingPaytrailAccount = true
      try {
        await axios.post(this.baseDomain + this.shopId + '/checkouthandler.json', {
          method: 'createMerchant'
        })
        await this.$store.dispatch('reloadSettings')
        this.showNotification(this._('Request sent') + '!')
      } catch (e) {
        this.showError((e.response && e.response.data && e.response.data.message) || this._('The operation failed!'))
      }
      this.creatingPaytrailAccount = false
    },
    async createVivaAccount (params) {
      let response
      const data = {
        method: 'createConnectedAccount',
        email: params.email,
        returnUrl: window.location.href + '#' + window.location.hash
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/vivahandler.json', data)
        this.showNotification(this._('Request sent') + '!')
      } catch (e) {
        this.showError(this._('The operation failed!'))
        return
      }
      await this.getVivaOnboardingStatus()
    },
    async getVivaOnboardingStatus () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/vivahandler.json', { method: 'getOnboardingStatus' })
      } catch (e) {
        return
      }
      this.vivaOnboardingStatuses = response.data || []
    },
    async checkVivaOnboardingStatus () {
      this.checkingVivaOnboardingStatus = true
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/vivahandler.json', { method: 'checkOnboardingStatus' })
        this.vivaOnboardingStatuses = response.data || []
      } catch (e) {
        this.showError(this._('The operation failed!'))
      }
      // The backend stored a verified account's merchant ID in the settings: show it without marking the form changed
      const verified = this.vivaOnboardingStatuses.find(status => status.status === 'VERIFIED' && status.merchantid)
      if (verified && !this.settings.pay_option19_merchantid) {
        const unchanged = this.getSaveDataString().replace(/(\\n|\\r)/g, '') === this.origState
        this.settings.pay_option19_merchantid = verified.merchantid
        if (unchanged) {
          this.storeState()
        }
      }
      this.checkingVivaOnboardingStatus = false
    },
    parseVivaOnboardingStatus (status) {
      switch (status) {
        case 'SENT':
          return this._('Waiting for registration')
        case 'CONNECTED':
          return this._('Waiting for verification by Viva')
      }
      return status
    },
    showMobilepayAttempts () {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'MobilepayAttemptsList',
        title: this._('MobilePay payment attempts'),
        width: 6,
        data: {}
      })
    },
    // Treat empty/"0" as unset; "pending" still counts as an in-progress value.
    // "0" can appear after settings backup/restore and would otherwise block re-onboarding.
    hasMobilepayMsnValue (msn) {
      return msn != null && msn !== '' && String(msn) !== '0'
    },
    isValidMobilepayMsn (msn) {
      return this.hasMobilepayMsnValue(msn) && msn !== 'pending'
    },
    normalizeInvalidMobilepayMsn (settings) {
      if (!settings) {
        return settings
      }
      if (String(settings.pay_option18_msn) === '0') {
        settings.pay_option18_msn = ''
      }
      if (String(settings.pay_option18_msn_pos) === '0') {
        settings.pay_option18_msn_pos = ''
      }
      return settings
    },
    async loadMobilepayPricePackages () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, { plugin: 'app', method: 'PricePackages' })
      } catch (e) {
        return []
      }
      return response.data
    },
    async onboardMobilepay (preselectedPurpose) {
      let pricePackages = await this.loadMobilepayPricePackages()
      this.showModal('mobilepayonboarding', MobilepayOnboarding, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          settings: this.settings,
          pricePackages: pricePackages,
          preselectedPurpose: preselectedPurpose
        },
        events: {
          done: (application) => {
            this.sendMobilepayOnboarding(application)
          }
        },
        handlers: {},
        width: 800
      })
    },
    async sendMobilepayOnboarding (application) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, { plugin: 'app', method: 'Onboarding', application: application })
      } catch (e) {
        this.showError(this._('The operation failed!'))
        return
      }
      this.showNotification(this._('Onboarding application sent!'))
      this.checkMobilepayOnboardingStatuses()
    },
    async getMobilepayOnboardingStatus () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, { plugin: 'app', method: 'GetOnboardingStatus' })
      } catch (e) {
        return
      }
      this.mobilepayOnboardingStatuses = (response.data || []).filter(status => status.type !== 'recurring')
    },
    async checkMobilepayRecurring () {
      this.checkingMobilepayRecurring = true
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, {
          plugin: 'app',
          method: 'CheckRecurring',
          msn: String(this.mobilepayRecurringMsnInput || '').trim()
        })
      } catch (e) {
        this.checkingMobilepayRecurring = false
        this.showError(e)
        return
      }
      this.checkingMobilepayRecurring = false
      this.settings.pay_option18_recurring = response.data.enabled ? 1 : 0
      this.settings.pay_option18_recurring_checked_ts = response.data.checked_ts
      this.settings.pay_option18_msn_recurring = response.data.msn || null
      this.mobilepayRecurringMsn = null
      if (response.data.enabled) {
        this.showNotification(this._('Automatic renewals with MobilePay are in use.'))
      } else {
        this.showError(this._('Recurring Payments have not been added to the sales unit yet.'))
      }
    },
    formatMobilepayCheckedTs (ts) {
      return ts ? DateTime.fromSeconds(Number(ts)).toFormat('d.M.yyyy HH:mm') : ''
    },
    async checkMobilepayOnboardingStatuses () {
      this.checkingMobilepayOnboardingStatuses = true
      for (let i = 0; i < this.mobilepayOnboardingStatuses.length; i++) {
        await this.checkMobilepayOnboardingStatus(this.mobilepayOnboardingStatuses[i].orderid)
      }
      await this.getMobilepayOnboardingStatus()
      this.checkingMobilepayOnboardingStatuses = false
    },
    async checkMobilepayOnboardingStatus (orderId) {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/mobilepayhandler.json?apikey=' + this.apiKey, { plugin: 'app', method: 'CheckOnboardingStatus', orderId: orderId })
      } catch (e) {
        return
      }
      return response.data
    },
    hasMobilepayOnboardingExpired (type) {
      if (type === 'online') {
        return this.mobilepayOnboardingStatuses.find(status => status.type === 'online' && status.status === 'EXPIRED')
      } else if (type === 'pos') {
        return this.mobilepayOnboardingStatuses.find(status => status.type === 'pos' && status.status === 'EXPIRED')
      }
    },
    parseMobilepayOnboardingStatus (status) {
      switch (status) {
        case 'SENT':
          return this._('Sent')
        case 'ERROR':
          return this._('Error')
        case 'RECEIVED':
          return this._('Received')
        case 'MERCHANT_VIEWED':
          return this._('Merchant viewed')
        case 'ORDER_SUBMITTED':
          return this._('Order submitted')
        case 'EXPIRED':
          return this._('Application expired') + '. ' + this._('Restart by clicking the Enable button.')
        case 'REJECTED':
          return this._('Rejected')
        case 'COMPLETED':
          return this._('Completed')
      }
    }
  },
  watch: {
    calendarAuthCode (newValue) {
      if (newValue && this.settings) {
        this.settings.calendarauthcode = newValue
        this.calendarAuthCode = null
      } 
    },
    isBankTransferSet (newValue) {
      if (!newValue) {
        this.settings.pay_option2 = 0
      }
    },
    isInvoiceSet (newValue) {
      if (!newValue) {
        this.settings.pay_option1 = 0
      }
    },
    isRopoInvoiceSet (newValue) {
      if (!newValue) {
        this.settings.pay_option7 = 0
      }
    },
    isNetvisorInvoiceSet (newValue) {
      if (!newValue) {
        this.settings.pay_option13 = 0
      }
    },
    isBrioxInvoiceSet (newValue) {
      if (!newValue) {
        this.settings.pay_option20 = 0
      }
    },
    isNocfoInvoiceSet (newValue) {
      if (!newValue) {
        this.settings.pay_option21 = 0
      }
    },
    isPaytrailLegacySet(newValue) {
      if (!newValue) {
        this.settings.pay_option5 = 0
      }
    },
    isPaytrailSet (newValue) {
      if (!newValue) {
        this.settings.pay_option6 = 0
      }
    },
    isPayPalSet (newValue) {
      if (!newValue) {
        this.settings.pay_option3 = 0
      }
    },
    isPayPalSandboxSet (newValue) {
      if (!newValue) {
        this.settings.pay_option4 = 0
      }
    },
    isVismaPaySet (newValue) {
      if (!newValue) {
        this.settings.pay_option9 = 0
      }
    },
    isStripeSet (newValue) {
      if (!newValue) {
        this.settings.pay_option8 = 0
      }
    },
    isAlipaySet (newValue) {
      if (!newValue) {
        this.settings.pay_option12 = 0
      }
    },
    isEpassiSet (newValue) {
      if (!newValue) {
        this.settings.pay_option15 = 0
      }
    },
    isNetaxeptSet (newValue) {
      if (!newValue) {
        this.settings.pay_option17 = 0
      }
    },
    isMobilePaySetOnline (newValue) {
      if (!newValue) {
        this.settings.pay_option18 = 0
      }
    },
    isVivaSet (newValue) {
      if (!newValue) {
        this.settings.pay_option19 = 0
      }
    }
  },
  components: {
    DraggableMultiSelector,
    UserDetails,
    Datatable,
    VismaBoarding,
    MobilepayOnboarding,
    PaymentPlansList,
    ShowLabelSettings
  },
  async mounted () {
    this.origLocale = this.locale
    const settings = this.normalizeInvalidMobilepayMsn(await this.loadVersionedSettings())
    this.localSettings = Object.assign({}, settings)
    this.uncheckInvalidPaymentMethods()
    this.origSettings = Object.assign({}, this.localSettings)
    this.settingsLocale = settings.locale
    this.storeState()
    this.loadUsers()
    if (settings.pay_option18_msn === 'pending' || settings.pay_option18_msn_pos === 'pending') {
      this.getMobilepayOnboardingStatus()
    }
    if (this.isFeatureEnabled('viva') && !settings.pay_option19_merchantid) {
      this.getVivaOnboardingStatus()
    }
    // gapi.load('client:auth2', this.initGapiClient)
    if (!this.events) {
      let events = {}
      events['voucherUpdate'] = (message) => {
        return this.reloadVouchersList()
      }
      events['tagUpdate'] = (message) => {
        return this.reloadTagsList()
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>